import { createHeadlessEditor as e } from "@lexical/headless";
import { AutoLinkNode as t, LinkNode as n } from "@lexical/link";
import { $convertToMarkdownString as r, TRANSFORMERS as i } from "@lexical/markdown";
import { $applyNodeReplacement as a, $getRoot as o, TextNode as s } from "lexical";
import { addClassNamesToElement as c } from "@lexical/utils";
import { z as l } from "zod";
import * as u from "rrule";
import { EOF as ee, EmbeddedActionsParser as d, Lexer as f, createToken as p } from "chevrotain";
import { createContext as te, useContext as ne, useMemo as re } from "react";
import { jsx as ie } from "react/jsx-runtime";
//#region src/UnreachableCaseError.ts
var ae = class extends Error {
	constructor(e) {
		super(`Unreachable case: ${JSON.stringify(e)}`);
	}
}, oe = {
	remove(e, t, n) {
		let r = e.find((e) => e.id === t);
		if (!r) return e;
		let i = r[n], a = r.order, o = [];
		for (let r = 0; r < e.length; r++) {
			let s = e[r];
			s.id !== t && (s[n] === i && s.order > a ? o.push({
				...s,
				order: s.order - 1
			}) : o.push(s));
		}
		return o;
	},
	insertAtOrder(e, t, n, r) {
		let i = t[r], a = 0;
		for (let t = 0; t < e.length; t++) e[t][r] === i && a++;
		let o = Math.max(0, Math.min(n, a)), s = [];
		for (let t = 0; t < e.length; t++) {
			let n = e[t];
			n[r] === i && n.order >= o ? s.push({
				...n,
				order: n.order + 1
			}) : s.push(n);
		}
		return s.push({
			...t,
			order: o
		}), s;
	},
	insertAtTheBottom(e, t, n) {
		return oe.insertAtOrder(e, t, Infinity, n);
	},
	move(e, t, n, r, i) {
		let a = e.find(function(e) {
			return e.id === t;
		});
		if (!a) return e;
		let o = a[i], s = a.order;
		if (o === n && s === r) return e;
		if (o !== n) return e.map(function(e) {
			return e.id === t ? {
				...e,
				[i]: n,
				order: r
			} : e[i] === o && e.order > s ? {
				...e,
				order: e.order - 1
			} : e[i] === n && e.order >= r ? {
				...e,
				order: e.order + 1
			} : e;
		});
		let c = s > r;
		return e.map(function(e) {
			if (e.id === t) return {
				...e,
				order: r
			};
			if (e[i] !== o) return e;
			if (c) {
				if (e.order >= r && e.order < s) return {
					...e,
					order: e.order + 1
				};
			} else if (e.order > s && e.order <= r) return {
				...e,
				order: e.order - 1
			};
			return e;
		});
	},
	moveByInstruction(e, t, n, r, i) {
		let a = e.find(function(e) {
			return e.id === t;
		}), o = e.find(function(e) {
			return e.id === n;
		});
		if (!a || !o) return e;
		let s = a[i], c = o[i], l, u;
		if (r === "make-child") l = n, u = 0;
		else if (r === "reorder-above") l = c, u = o.order, s === c && a.order < o.order && (u = o.order - 1);
		else if (r === "reorder-below" || r === "reparent") l = c, u = o.order + 1, s === c && a.order < o.order && (u = o.order);
		else return e;
		return oe.move(e, t, l, u, i);
	}
}, se = {
	remove(e, t, n) {
		let r = t.order;
		for (let e of n) e !== t && e.order > r && --e.order;
		let i = e.indexOf(t);
		i !== -1 && e.splice(i, 1);
	},
	insertAtTheBottom(e, t, n) {
		let r = -1;
		for (let e of n) e.order > r && (r = e.order);
		t.order = r + 1, e.push(t);
	},
	insertAtOrder(e, t, n, r) {
		let i = Math.max(0, Math.min(n, r.length));
		for (let e of r) e.order >= i && (e.order += 1);
		t.order = i, e.push(t);
	},
	move(e, t, n, r, i, a) {
		let o = e.order, s = t === n;
		if (s && o === r) return;
		if (!s) {
			for (let n of t) n !== e && n.order > o && --n.order;
			for (let e of n) e.order >= r && (e.order += 1);
			e[a] = i, e.order = r;
			return;
		}
		let c = o > r;
		for (let n of t) {
			if (n === e) {
				n.order = r;
				continue;
			}
			c ? n.order >= r && n.order < o && (n.order += 1) : n.order > o && n.order <= r && --n.order;
		}
	},
	moveByInstruction(e, t, n, r, i, a) {
		let o = e[a], s = t[a], c, l;
		if (i === "make-child") c = t.id, l = 0;
		else if (i === "reorder-above") c = s, l = t.order, o === s && e.order < t.order && (l = t.order - 1);
		else if (i === "reorder-below" || i === "reparent") c = s, l = t.order + 1, o === s && e.order < t.order && (l = t.order);
		else return;
		se.move(e, n, r, l, c, a);
	}
};
//#endregion
//#region src/assert.ts
function m(e, t) {
	if (!e) throw Error(t);
}
//#endregion
//#region src/calendarFetchRange.ts
var ce = 12, le = 50;
//#endregion
//#region src/convertFromUTCDate.ts
function ue(e) {
	let t = e.getUTCFullYear(), n = e.getUTCMonth(), r = e.getUTCDate(), i = e.getUTCHours(), a = e.getUTCMinutes(), o = e.getUTCSeconds(), s = e.getUTCMilliseconds();
	return new Date(t, n, r, i, a, o, s);
}
//#endregion
//#region src/convertToUTCDate.ts
function de(e) {
	return new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
}
//#endregion
//#region src/genRandomColorHex.ts
function fe() {
	return "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0");
}
//#endregion
//#region src/getDaysBetween.ts
function pe(e, t) {
	let n = [], r = new Date(e.getTime());
	for (; r <= t;) n.push(new Date(r)), r.setDate(r.getDate() + 1);
	return n;
}
//#endregion
//#region src/groupBy.ts
function me(e, t) {
	return e.reduce((e, n) => {
		let r = t(n);
		return e[r] = e[r] ? [...e[r], n] : [n], e;
	}, {});
}
//#endregion
//#region src/isPhoneNumberValid.ts
function he(e) {
	let t = /* @__PURE__ */ new RegExp(/(?<!\w)(\(?(\+|00)?48\)?)?[ -]?\d{3}[ -]?\d{3}[ -]?\d{3}(?!\w)/g);
	return !!e.match(t);
}
//#endregion
//#region src/mapBy.ts
function ge(e, t) {
	return e.reduce((e, n) => {
		let r = t(n);
		return e[r] = n, e;
	}, {});
}
//#endregion
//#region src/noop.ts
function _e() {}
//#endregion
//#region src/ord.ts
function ve(e, t) {
	return e > t;
}
function ye(e, t) {
	return e < t;
}
function be(e, t) {
	return ve(e, t) ? {
		update: { order: { increment: 1 } },
		range: {
			gte: t,
			lt: e
		}
	} : {
		update: { order: { decrement: 1 } },
		range: {
			gt: e,
			lte: t
		}
	};
}
//#endregion
//#region src/range.ts
function xe(e, t) {
	t === void 0 && (t = e, e = 0);
	let n = [];
	for (let r = e; r < t; r++) n.push(r);
	return n;
}
//#endregion
//#region src/resolveProgramPhase.ts
function Se(e, t) {
	let n = Math.floor(t / 7), r = e.find((e) => e.startWeek <= n && n < e.endWeek);
	return r ? {
		...r,
		programWeekNumber: n + 1,
		phaseWeekNumber: n - r.startWeek + 1,
		phaseWeekCount: r.endWeek - r.startWeek
	} : null;
}
//#endregion
//#region src/reorder.ts
function Ce(e, t, n) {
	let r = [...e], [i] = r.splice(t, 1);
	return r.splice(n, 0, i), r;
}
//#endregion
//#region src/getRelativeTime.ts
function we(e) {
	let t = /* @__PURE__ */ new Date(), n = Math.abs(e.getTime() - t.getTime()), r = Math.sign(e.getTime() - t.getTime()), i = {
		val: 0,
		range: "second"
	};
	if (n === 0) return i;
	for (let e of [
		{
			type: "second",
			seconds: 1e3,
			max: 60
		},
		{
			type: "minute",
			seconds: 60 * 1e3,
			max: 60
		},
		{
			type: "hour",
			seconds: 3600 * 1e3,
			max: 24
		},
		{
			type: "day",
			seconds: 1440 * 60 * 1e3,
			max: 7
		},
		{
			type: "week",
			seconds: 10080 * 60 * 1e3,
			max: 4
		},
		{
			type: "month",
			seconds: 720 * 60 * 60 * 1e3,
			max: 12
		},
		{
			type: "year",
			seconds: 360 * 24 * 60 * 60 * 1e3,
			max: Infinity
		}
	]) {
		let t = Math.round(n / e.seconds);
		if (t >= 0 && t < e.max) {
			i = {
				val: t * r,
				range: e.type
			};
			break;
		}
	}
	return i;
}
//#endregion
//#region src/capitalize.ts
function Te(e) {
	return e.charAt(0).toUpperCase() + e.slice(1);
}
//#endregion
//#region src/isDateWithoutTime.ts
function Ee(e) {
	if (!e) return !0;
	let t = new Date(e);
	return t.getUTCHours() === 0 && t.getUTCMinutes() === 0 && t.getUTCSeconds() === 0 && t.getUTCMilliseconds() === 0;
}
//#endregion
//#region src/getAlphabetLetter.ts
function De(e) {
	let t = "";
	for (; e >= 0;) t = String.fromCharCode(65 + e % 26) + t, e = Math.floor(e / 26) - 1;
	return t;
}
//#endregion
//#region src/getInitials.ts
function Oe(e) {
	return e.split(" ").map((e) => e[0]).join("").toUpperCase();
}
//#endregion
//#region src/muscleGroups.ts
var ke = [
	{
		name: "Adductors",
		muscles: [
			{ name: "Adductors" },
			{ name: "Groin" },
			{ name: "Hip flexors" },
			{ name: "Inner thighs" }
		]
	},
	{
		name: "Abdominals",
		muscles: [
			{ name: "Abdominals" },
			{ name: "Core" },
			{ name: "Lower abs" }
		]
	},
	{
		name: "Obliques",
		muscles: [{ name: "Obliques" }]
	},
	{
		name: "Biceps",
		muscles: [{ name: "Biceps" }, { name: "Brachialis" }]
	},
	{
		name: "Triceps",
		muscles: [{ name: "Triceps" }]
	},
	{
		name: "Deltoids",
		muscles: [
			{ name: "Deltoids" },
			{ name: "Shoulders" },
			{ name: "Rotator cuff" }
		]
	},
	{
		name: "Serratus anterior",
		muscles: [{ name: "Serratus anterior" }]
	},
	{
		name: "Trapezius",
		muscles: [{ name: "Trapezius" }]
	},
	{
		name: "Chest",
		muscles: [
			{ name: "Chest" },
			{ name: "Pectorals" },
			{ name: "Upper chest" }
		]
	},
	{
		name: "Forearms",
		muscles: [{ name: "Forearms" }]
	},
	{
		name: "Abductors",
		muscles: [{ name: "Abductors" }]
	},
	{
		name: "Quadriceps",
		muscles: [{ name: "Quadriceps" }]
	},
	{
		name: "Calves",
		muscles: [
			{ name: "Calves" },
			{ name: "Shins" },
			{ name: "Tibialis anterior" }
		]
	},
	{
		name: "Neck",
		muscles: [{ name: "Sternocleidomastoid" }]
	},
	{
		name: "Back",
		muscles: [
			{ name: "Lats" },
			{ name: "Back" },
			{ name: "Trapezius" },
			{ name: "Rhomboids" },
			{ name: "Upper back" }
		]
	},
	{
		name: "Glutes",
		muscles: [{ name: "Glutes" }, { name: "Hip rotators" }]
	},
	{
		name: "Hamstrings",
		muscles: [
			{ name: "Hamstrings" },
			{ name: "Groin" },
			{ name: "Hip flexors" },
			{ name: "Inner thighs" }
		]
	},
	{
		name: "Lower back",
		muscles: [{ name: "Lower back" }, { name: "Erector spinae" }]
	},
	{
		name: "Full body",
		muscles: [{ name: "Full body" }]
	},
	{
		name: "Upper body",
		muscles: [{ name: "Upper body" }]
	},
	{
		name: "Lower body",
		muscles: [{ name: "Lower body" }]
	},
	{
		name: "Posterior chain",
		muscles: [{ name: "Posterior chain" }]
	}
];
function Ae(...e) {
	return e.map((e) => ke.find((t) => t.name === e)).filter((e) => e !== void 0);
}
function je(e) {
	let t = [];
	for (let n of ke) if (e.includes(n.name)) for (let e of n.muscles) t.push(e.name);
	return t;
}
//#endregion
//#region src/lexicalStateToMarkdown.ts
function Me(a) {
	let o = e({ nodes: [t, n] }), s = "", c = o.parseEditorState(a);
	return o.setEditorState(c), o.read(() => {
		s = r(i);
	}), s;
}
//#endregion
//#region src/markdownToLexicalState.ts
function Ne(e) {
	let t = [], n = e.split("\n");
	for (let e = 0; e < n.length; e++) {
		let r = n[e];
		r.length > 0 && t.push({
			detail: 0,
			format: 0,
			mode: "normal",
			style: "",
			text: r,
			type: "text",
			version: 1
		}), e < n.length - 1 && t.push({
			type: "linebreak",
			version: 1
		});
	}
	return t.length === 0 && t.push({
		detail: 0,
		format: 0,
		mode: "normal",
		style: "",
		text: "",
		type: "text",
		version: 1
	}), { root: {
		children: [{
			children: t,
			direction: null,
			format: "",
			indent: 0,
			type: "paragraph",
			version: 1,
			textFormat: 0,
			textStyle: ""
		}],
		direction: null,
		format: "",
		indent: 0,
		type: "root",
		version: 1
	} };
}
//#endregion
//#region src/VariableNode.ts
var Pe = class e extends s {
	__variable;
	static getType() {
		return "variable";
	}
	static clone(t) {
		return new e(t.__variable, t.__text, t.__key);
	}
	static importJSON(e) {
		return Fe(e.variable, e.text).updateFromJSON(e);
	}
	constructor(e, t, n) {
		super(t, n), this.__variable = e;
	}
	getVariable() {
		return this.getLatest().__variable;
	}
	exportJSON() {
		return {
			...super.exportJSON(),
			type: "variable",
			variable: this.__variable
		};
	}
	createDOM(e) {
		let t = super.createDOM(e);
		return c(t, e.theme.variable), t;
	}
	isTextEntity() {
		return !0;
	}
	canInsertTextBefore() {
		return !1;
	}
	canInsertTextAfter() {
		return !1;
	}
};
function Fe(e, t) {
	return a(new Pe(e, t).setMode("token"));
}
function Ie(e) {
	return e instanceof Pe;
}
//#endregion
//#region src/lexicalStateToString.ts
function Le(r) {
	if (!r.root.children || r.root.children.length === 0) return "";
	let i = e({ nodes: [
		t,
		n,
		Pe
	] }), a = "", s = i.parseEditorState(r);
	return i.setEditorState(s), i.read(() => {
		a = o().getTextContent();
	}), a;
}
//#endregion
//#region src/isLexicalJsonState.ts
function Re(e) {
	return !!(e && typeof e == "object" && Object.hasOwn(e, "root") && "root" in e && e.root && typeof e.root == "object" && "children" in e.root && Array.isArray(e.root.children));
}
//#endregion
//#region src/isEmptyLexicalState.ts
function ze(e) {
	let t = e.root;
	if (!t.children || t.children.length === 0) return !0;
	let n = t.children[0];
	return !!(t.children.length === 1 && n.type === "paragraph" && "children" in n && Array.isArray(n.children) && n.children.length === 0);
}
//#endregion
//#region src/emptyLexicalState.ts
function Be() {
	return { root: {
		type: "root",
		format: "",
		indent: 0,
		version: 1,
		direction: null,
		children: []
	} };
}
//#endregion
//#region src/stringToLexicalState.ts
var Ve = /((https?:\/\/(www\.)?)|(www\.)|(?<=^|\s))[-a-zA-Z0-9@:%._+~#=]{1,256}\.(com|org|net|edu|gov|io|co|pl|de|uk|us|app|dev|ai|me|info|biz)(?:[\\/?#][-a-zA-Z0-9()@:%_+.~#?&//=]*)?(?=$|\s|[.,!?;])/g;
function He(e) {
	return e.startsWith("http") ? e : `https://${e}`;
}
function Ue(e) {
	let t = [], n = 0;
	Ve.lastIndex = 0;
	let r;
	for (; (r = Ve.exec(e)) !== null;) {
		let i = r[0], a = r.index;
		if (a > n) {
			let r = e.substring(n, a);
			t.push({
				detail: 0,
				format: 0,
				mode: "normal",
				style: "",
				text: r,
				type: "text",
				version: 1
			});
		}
		t.push({
			children: [{
				detail: 0,
				format: 0,
				mode: "normal",
				style: "",
				text: i,
				type: "text",
				version: 1
			}],
			direction: null,
			format: "",
			indent: 0,
			type: "autolink",
			version: 1,
			rel: null,
			target: null,
			title: null,
			url: He(i),
			isUnlinked: !1
		}), n = a + i.length;
	}
	if (n < e.length) {
		let r = e.substring(n);
		t.push({
			detail: 0,
			format: 0,
			mode: "normal",
			style: "",
			text: r,
			type: "text",
			version: 1
		});
	}
	return t;
}
function We(e) {
	let t = [], n = e.split("\n");
	for (let e = 0; e < n.length; e++) {
		let r = n[e];
		if (r.length > 0) {
			let e = Ue(r);
			t.push(...e);
		}
		e < n.length - 1 && t.push({
			type: "linebreak",
			version: 1
		});
	}
	return t.length === 0 && t.push({
		detail: 0,
		format: 0,
		mode: "normal",
		style: "",
		text: "",
		type: "text",
		version: 1
	}), { root: {
		children: [{
			children: t,
			direction: null,
			format: "",
			indent: 0,
			type: "paragraph",
			version: 1,
			textFormat: 0,
			textStyle: ""
		}],
		direction: null,
		format: "",
		indent: 0,
		type: "root",
		version: 1
	} };
}
//#endregion
//#region src/mapLexicalState.ts
function Ge(e, t) {
	function n(e, r) {
		return t(e, "children" in e && e.children ? e.children.map((e, t) => n(e, t)) : [], r);
	}
	return n(e.root, 0);
}
//#endregion
//#region src/getColorFromInitials.ts
var Ke = [
	200,
	210,
	230,
	260,
	280,
	25,
	10,
	350,
	320,
	130
];
function qe(e) {
	let t = e.split("").reduce((e, t) => t.charCodeAt(0) + ((e << 5) - e), 0);
	return `hsl(${Ke[Math.abs(t) % Ke.length]}, 60%, 40%)`;
}
//#endregion
//#region src/getContrastTextColor.ts
function Je(e) {
	let t = Ye(e);
	if (t) return .2126 * t.r + .7152 * t.g + .0722 * t.b > .5 ? "black" : "white";
	let n = e.match(/hsl\((\d+),\s*(\d+)%,\s*(\d+)%\)/);
	if (!n) return "white";
	let [, r, i, a] = n.map(Number), o = r / 360, s = i / 100, c = a / 100, l = (1 - Math.abs(2 * c - 1)) * s, u = l * (1 - Math.abs(o * 6 % 2 - 1)), ee = c - l / 2, d = 0, f = 0, p = 0;
	return o < 1 / 6 ? [d, f, p] = [
		l,
		u,
		0
	] : o < 2 / 6 ? [d, f, p] = [
		u,
		l,
		0
	] : o < 3 / 6 ? [d, f, p] = [
		0,
		l,
		u
	] : o < 4 / 6 ? [d, f, p] = [
		0,
		u,
		l
	] : o < 5 / 6 ? [d, f, p] = [
		u,
		0,
		l
	] : [d, f, p] = [
		l,
		0,
		u
	], .2126 * (d + ee) + .7152 * (f + ee) + .0722 * (p + ee) > .5 ? "black" : "white";
}
function Ye(e) {
	let t = e.trim(), n = t.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
	if (n) return {
		r: parseInt(`${n[1]}${n[1]}`, 16) / 255,
		g: parseInt(`${n[2]}${n[2]}`, 16) / 255,
		b: parseInt(`${n[3]}${n[3]}`, 16) / 255
	};
	let r = t.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
	return r ? {
		r: parseInt(r[1], 16) / 255,
		g: parseInt(r[2], 16) / 255,
		b: parseInt(r[3], 16) / 255
	} : null;
}
//#endregion
//#region src/getFileUrl.ts
function Xe(e) {
	return typeof process < "u" && process.env?.APP_ENV === "development" ? `https://files-dev.sztama.app/${e}` : `https://files.sztama.app/${e}`;
}
//#endregion
//#region src/formatMessageDate.ts
function Ze(e) {
	let t = typeof e == "string" ? new Date(e) : e, n = /* @__PURE__ */ new Date(), r = new Date(n.getFullYear(), n.getMonth(), n.getDate()), i = new Date(t.getFullYear(), t.getMonth(), t.getDate()), a = Math.floor((r.getTime() - i.getTime()) / (1e3 * 60 * 60 * 24));
	return a === 0 ? {
		type: "today",
		date: t
	} : a === 1 ? {
		type: "yesterday",
		date: t
	} : {
		type: "older",
		date: t
	};
}
//#endregion
//#region src/formatCommentDate.ts
var Qe = [
	"sunday",
	"monday",
	"tuesday",
	"wednesday",
	"thursday",
	"friday",
	"saturday"
];
function $e(e) {
	return e.toLocaleTimeString([], {
		hour: "2-digit",
		minute: "2-digit",
		hour12: !1
	});
}
function et(e, t) {
	return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}
function tt(e, t) {
	let n = new Date(t);
	return n.setDate(n.getDate() - 1), et(e, n);
}
function nt(e, t) {
	let n = new Date(t);
	n.setHours(0, 0, 0, 0);
	let r = new Date(e);
	r.setHours(0, 0, 0, 0);
	let i = n.getTime() - r.getTime();
	return Math.floor(i / (1e3 * 60 * 60 * 24));
}
function rt(e) {
	let t = e.now ?? /* @__PURE__ */ new Date(), n = new Date(e.dateString), r = $e(n);
	if (et(n, t)) return r;
	if (tt(n, t)) return `${e.translations.yesterday} ${r}`;
	if (nt(n, t) <= 5) {
		let t = n.getDay();
		return `${e.translations[Qe[t]]} ${r}`;
	}
	return n.toLocaleString([], {
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		hour12: !1
	});
}
//#endregion
//#region src/chat/processMessages.ts
var it = 15, at = [
	"sunday",
	"monday",
	"tuesday",
	"wednesday",
	"thursday",
	"friday",
	"saturday"
], ot = 60 * 1e3, st = 1440 * ot;
function ct(e) {
	return new Date(e.getFullYear(), e.getMonth(), e.getDate());
}
function lt(e, t) {
	return Math.floor((ct(t).getTime() - ct(e).getTime()) / st);
}
function ut(e) {
	return `${e.getFullYear()}-${String(e.getMonth() + 1).padStart(2, "0")}-${String(e.getDate()).padStart(2, "0")}`;
}
function dt(e) {
	return `${String(e.getHours()).padStart(2, "0")}:${String(e.getMinutes()).padStart(2, "0")}`;
}
function ft(e, t) {
	return t[at[e.getDay()]];
}
function pt(e) {
	return e.toLocaleDateString([], {
		day: "numeric",
		month: "short"
	});
}
function mt(e, t, n) {
	let r = lt(e, n);
	return r === 0 ? null : r === 1 ? t.yesterday : r < 7 ? ft(e, t) : pt(e);
}
function ht(e, t, n) {
	let r = dt(e), i = lt(e, n);
	return i === 0 ? r : i === 1 ? `${t.yesterday} ${r}` : i < 7 ? `${ft(e, t)} ${r}` : `${pt(e)} ${r}`;
}
function gt(e, t) {
	return Math.abs(e.getTime() - t.getTime()) / ot;
}
function _t(e, t) {
	if (!t) return !0;
	let n = new Date(e.createdAt), r = new Date(t.createdAt);
	return ut(n) === ut(r) ? gt(n, r) >= 15 : !0;
}
function vt(e, t) {
	return e.sender.id === t.sender.id && !_t(e, t);
}
function yt(e, t, n = /* @__PURE__ */ new Date()) {
	if (e.length === 0) return [];
	let r = [];
	for (let i = 0; i < e.length; i++) {
		let a = e[i], o = new Date(a.createdAt), s = ut(o), c = i > 0 ? e[i - 1] : null, l = i < e.length - 1 ? e[i + 1] : null;
		r.push({
			type: "message",
			id: a.id,
			data: a,
			showTime: _t(a, l),
			isGroupStart: !l || !vt(a, l),
			isGroupEnd: !c || !vt(c, a),
			timeLabel: dt(o),
			fullTimestamp: ht(o, t, n)
		});
		let u = l ? ut(new Date(l.createdAt)) : null;
		if (u !== null && s !== u) {
			let e = mt(o, t, n);
			e !== null && r.push({
				type: "date",
				id: `date-${s}`,
				date: s,
				label: e
			});
		}
	}
	return r;
}
function bt(e, t, n) {
	return t && n ? "rounded-[18px]" : e ? t ? "rounded-tl-[18px] rounded-tr-[18px] rounded-bl-[18px] rounded-br-[4px]" : n ? "rounded-tl-[18px] rounded-tr-[4px] rounded-bl-[18px] rounded-br-[18px]" : "rounded-tl-[18px] rounded-tr-[4px] rounded-bl-[18px] rounded-br-[4px]" : t ? "rounded-tl-[18px] rounded-tr-[18px] rounded-bl-[4px] rounded-br-[18px]" : n ? "rounded-tl-[4px] rounded-tr-[18px] rounded-bl-[18px] rounded-br-[18px]" : "rounded-tl-[4px] rounded-tr-[18px] rounded-bl-[4px] rounded-br-[18px]";
}
//#endregion
//#region src/chat/queryKeys.ts
var xt = {
	ROOT: "chat",
	MY_CHATS: "getMyChats",
	MESSAGES: "getMessages"
}, St = {
	COMPRESSING: "compressing",
	UPLOADING: "uploading",
	DONE: "done",
	ERROR: "error"
};
function Ct(e) {
	return e === St.COMPRESSING || e === St.UPLOADING;
}
function wt(e) {
	return e.status === St.DONE && typeof e.uploadedFileId == "string";
}
//#endregion
//#region src/chat/classifyMessageContent.ts
function Tt(e) {
	return typeof e == "string" ? e.trim().length === 0 ? { kind: "empty" } : {
		kind: "plain",
		text: e
	} : Re(e) ? Le(e).trim().length === 0 ? { kind: "empty" } : {
		kind: "lexical",
		value: e
	} : { kind: "empty" };
}
//#endregion
//#region src/chat/chatMediaValidation.ts
var h = 1024 * 1024, g = {
	IMAGE_JPEG: "image/jpeg",
	IMAGE_PNG: "image/png",
	IMAGE_WEBP: "image/webp",
	IMAGE_GIF: "image/gif",
	VIDEO_MP4: "video/mp4",
	VIDEO_QUICKTIME: "video/quicktime",
	VIDEO_WEBM: "video/webm",
	APPLICATION_PDF: "application/pdf",
	APPLICATION_MSWORD: "application/msword",
	APPLICATION_DOCX: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	APPLICATION_EXCEL: "application/vnd.ms-excel",
	APPLICATION_XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	TEXT_PLAIN: "text/plain",
	TEXT_CSV: "text/csv"
}, _ = {
	IMAGE_MAX_BYTES: 10 * h,
	VIDEO_MAX_BYTES: 25 * h,
	DOCUMENT_MAX_BYTES: 10 * h,
	IMAGE_SOURCE_MAX_BYTES: 50 * h,
	MAX_ATTACHMENTS_PER_MESSAGE: 10,
	ALLOWED_IMAGE_MIMES: [
		g.IMAGE_JPEG,
		g.IMAGE_PNG,
		g.IMAGE_WEBP,
		g.IMAGE_GIF
	],
	ALLOWED_VIDEO_MIMES: [
		g.VIDEO_MP4,
		g.VIDEO_QUICKTIME,
		g.VIDEO_WEBM
	],
	ALLOWED_DOCUMENT_MIMES: [
		g.APPLICATION_PDF,
		g.APPLICATION_MSWORD,
		g.APPLICATION_DOCX,
		g.APPLICATION_EXCEL,
		g.APPLICATION_XLSX,
		g.TEXT_PLAIN,
		g.TEXT_CSV
	]
}, Et = {
	IMAGE_TARGET_LONG_EDGE: 1920,
	IMAGE_JPEG_QUALITY: .75,
	IMAGE_MAX_MEGAPIXELS_FOR_SINGLE_PASS_DECODE: 24,
	VIDEO_TARGET_LONG_EDGE: 720,
	VIDEO_TARGET_BITRATE_PRIMARY_BPS: 2e6,
	VIDEO_TARGET_FALLBACK_LONG_EDGE: 540,
	VIDEO_TARGET_BITRATE_FALLBACK_BPS: 12e5,
	VIDEO_AUDIO_BITRATE_BPS: 128e3,
	VIDEO_PROGRESS_PRIMARY_END: .6
}, Dt = {
	[g.IMAGE_JPEG]: [".jpg", ".jpeg"],
	[g.IMAGE_PNG]: [".png"],
	[g.IMAGE_WEBP]: [".webp"],
	[g.IMAGE_GIF]: [".gif"],
	[g.VIDEO_MP4]: [".mp4"],
	[g.VIDEO_QUICKTIME]: [".mov", ".qt"],
	[g.VIDEO_WEBM]: [".webm"],
	[g.APPLICATION_PDF]: [".pdf"],
	[g.APPLICATION_MSWORD]: [".doc"],
	[g.APPLICATION_DOCX]: [".docx"],
	[g.APPLICATION_EXCEL]: [".xls"],
	[g.APPLICATION_XLSX]: [".xlsx"],
	[g.TEXT_PLAIN]: [".txt"],
	[g.TEXT_CSV]: [".csv"]
}, Ot = (function() {
	let e = {};
	for (let t of Object.keys(Dt)) for (let n of Dt[t]) e[n.toLowerCase()] = t;
	return e;
})();
function kt(e) {
	let t = e.toLowerCase(), n = t.lastIndexOf(".");
	return Ot[n >= 0 ? t.slice(n) : `.${t}`] ?? null;
}
var v = {
	image: {
		mimes: _.ALLOWED_IMAGE_MIMES,
		maxBytes: _.IMAGE_MAX_BYTES
	},
	video: {
		mimes: _.ALLOWED_VIDEO_MIMES,
		maxBytes: _.VIDEO_MAX_BYTES
	},
	document: {
		mimes: _.ALLOWED_DOCUMENT_MIMES,
		maxBytes: _.DOCUMENT_MAX_BYTES
	}
};
function At(e) {
	let t = new Set(e);
	return function(e) {
		return t.has(e);
	};
}
var jt = At(v.image.mimes), Mt = At(v.video.mimes), Nt = At(v.document.mimes);
function Pt(e) {
	return jt(e) || Mt(e) || Nt(e);
}
function Ft(e) {
	for (let t of Object.values(v)) if (t.mimes.includes(e)) return t.maxBytes;
	return v.document.maxBytes;
}
//#endregion
//#region src/chat/editWindow.ts
var It = 900 * 1e3, y = {
	CHAT_GONE: "CHAT_GONE",
	MESSAGE_ID_CONFLICT: "MESSAGE_ID_CONFLICT",
	EDIT_WINDOW_EXPIRED: "EDIT_WINDOW_EXPIRED",
	EDIT_FORBIDDEN: "EDIT_FORBIDDEN",
	EDIT_EMPTY: "EDIT_EMPTY",
	DELETE_FORBIDDEN: "DELETE_FORBIDDEN",
	ALREADY_ATTACHED: "ALREADY_ATTACHED",
	ATTACHMENT_OWNERSHIP_DENIED: "ATTACHMENT_OWNERSHIP_DENIED",
	ATTACHMENT_LIMIT_EXCEEDED: "ATTACHMENT_LIMIT_EXCEEDED"
}, Lt = new Set(Object.values(y));
function Rt(e) {
	return typeof e == "string" && Lt.has(e);
}
function zt(e) {
	if (typeof e != "object" || !e) return null;
	let t = e.error;
	if (typeof t != "object" || !t) return null;
	let n = t.code;
	return typeof n == "string" && Rt(n) ? n : null;
}
function Bt(e, t) {
	return t === "edit" ? e === y.EDIT_WINDOW_EXPIRED ? "edit.windowExpired" : e === y.EDIT_FORBIDDEN ? "edit.forbidden" : e === y.EDIT_EMPTY ? "edit.empty" : "edit.generic" : t === "delete" ? e === y.DELETE_FORBIDDEN ? "delete.forbidden" : "delete.generic" : e === y.CHAT_GONE ? "send.chatGone" : e === y.ATTACHMENT_OWNERSHIP_DENIED ? "send.attachmentOwnershipDenied" : e === y.ATTACHMENT_LIMIT_EXCEEDED ? "send.attachmentLimitExceeded" : e === y.MESSAGE_ID_CONFLICT ? "send.messageIdConflict" : "send.generic";
}
//#endregion
//#region src/chat/FileTooLargeError.ts
var Vt = class extends Error {
	fileSizeMB;
	maxSizeMB;
	constructor(e) {
		super(`File too large (${e.fileSizeMB}MB). Max: ${e.maxSizeMB}MB`), this.name = "FileTooLargeError", this.fileSizeMB = e.fileSizeMB, this.maxSizeMB = e.maxSizeMB;
	}
};
function Ht(e) {
	if (!(e instanceof Error) || e.name !== "FileTooLargeError") return !1;
	let t = e;
	return typeof t.fileSizeMB == "number" && typeof t.maxSizeMB == "number";
}
//#endregion
//#region src/chat/messageContentSchema.ts
var Ut = 64 * 1024, Wt = 32;
function Gt(e) {
	if (typeof e != "object" || !e || Array.isArray(e)) return !1;
	let t = e.root;
	if (typeof t != "object" || !t || Array.isArray(t)) return !1;
	let n = t.children;
	return Array.isArray(n);
}
function Kt(e, t) {
	if (!Gt(e)) return !1;
	let n = e.root.children, r = [];
	for (let e of n) r.push([e, 1]);
	for (; r.length > 0;) {
		let [e, n] = r.pop();
		if (n > t) return !0;
		if (typeof e != "object" || !e || Array.isArray(e)) continue;
		let i = e.children;
		if (Array.isArray(i)) for (let e of i) r.push([e, n + 1]);
	}
	return !1;
}
var qt = l.unknown().superRefine(function(e, t) {
	if (typeof e != "string" && !Gt(e)) {
		t.addIssue({
			code: "custom",
			message: "Message content must be a string or a Lexical JSON state with a `root.children` array"
		});
		return;
	}
	let n;
	try {
		n = JSON.stringify(e);
	} catch (e) {
		t.addIssue({
			code: "custom",
			message: `Message content must be JSON-serializable: ${e instanceof Error ? e.message : String(e)}`
		});
		return;
	}
	if (typeof n != "string") {
		t.addIssue({
			code: "custom",
			message: "Message content must be JSON-serializable"
		});
		return;
	}
	if (n.length > Ut) {
		t.addIssue({
			code: "custom",
			message: `Message content exceeds ${Ut} characters`
		});
		return;
	}
	Kt(e, Wt) && t.addIssue({
		code: "custom",
		message: `Message content nests more than ${Wt} levels deep`
	});
}), Jt = class extends Error {
	constructor(e) {
		super(`Animated GIF is too large. Maximum: ${Math.round(e / h)} MB.`), this.name = "AnimatedGifTooLargeError";
	}
}, Yt = class extends Error {
	constructor(e) {
		super(`Video is too long to compress under ${Math.round(e / h)} MB. Please trim and try again.`), this.name = "VideoTooLargeAfterCompressionError";
	}
};
function Xt(e) {
	return e instanceof Error && e.name === "AnimatedGifTooLargeError";
}
function Zt(e) {
	return e instanceof Error && e.name === "VideoTooLargeAfterCompressionError";
}
//#endregion
//#region src/chat/uploadErrors.ts
var b = {
	BAD_REQUEST: 400,
	PAYLOAD_TOO_LARGE: 413,
	UNSUPPORTED_MEDIA_TYPE: 415,
	TOO_MANY_REQUESTS: 429
}, Qt = class extends Error {
	status;
	code;
	userMessage;
	constructor(e) {
		super(e.userMessage), this.name = "ChatMediaUploadError", this.status = e.status, this.code = e.code, this.userMessage = e.userMessage;
	}
};
function $t(e) {
	if (!(e instanceof Error) || e.name !== "ChatMediaUploadError") return !1;
	let t = e;
	return typeof t.status == "number" && typeof t.userMessage == "string";
}
async function en(e) {
	let t, n = `Upload failed: ${e.status}`;
	try {
		let r = await e.json();
		r.error?.message && (n = r.error.message), r.error?.code && (t = r.error.code);
	} catch {}
	return new Qt({
		status: e.status,
		code: t,
		userMessage: n
	});
}
var x = {
	FILE_TOO_LARGE: "fileTooLarge",
	SERVER_ERROR: "serverError",
	COMPRESSION_INVALID: "compressionInvalid"
}, S = {
	FILE_TOO_LARGE_WITH_SIZE: "fileTooLargeWithSize",
	FILE_TOO_LARGE_NO_SIZE: "fileTooLargeNoSize",
	PAYLOAD_TOO_LARGE: "payloadTooLarge",
	UNSUPPORTED_MEDIA_TYPE: "unsupportedMediaType",
	UNSUPPORTED_FORMAT: "unsupportedFormat",
	RATE_LIMITED: "rateLimited",
	BAD_REQUEST: "badRequest",
	GENERIC: "generic"
};
function tn(e) {
	if (!(e instanceof Error) || e.name !== "CompressionInvalidOutputError") return !1;
	let t = e;
	return t.kind === "image" || t.kind === "video";
}
function nn(e) {
	return Ht(e) ? {
		kind: x.FILE_TOO_LARGE,
		fileSizeMB: e.fileSizeMB,
		maxSizeMB: e.maxSizeMB
	} : Zt(e) ? {
		kind: x.FILE_TOO_LARGE,
		maxSizeMB: Math.round(_.VIDEO_MAX_BYTES / h)
	} : Xt(e) ? {
		kind: x.FILE_TOO_LARGE,
		maxSizeMB: Math.round(_.IMAGE_MAX_BYTES / h)
	} : tn(e) ? {
		kind: x.COMPRESSION_INVALID,
		mediaKind: e.kind
	} : $t(e) ? {
		kind: x.SERVER_ERROR,
		status: e.status,
		userMessage: e.userMessage
	} : { kind: x.SERVER_ERROR };
}
function rn(e) {
	if (e === void 0) return {
		kind: S.GENERIC,
		isRetryable: !0
	};
	if (e.kind === x.FILE_TOO_LARGE) return typeof e.fileSizeMB == "number" ? {
		kind: S.FILE_TOO_LARGE_WITH_SIZE,
		fileSizeMB: e.fileSizeMB,
		maxSizeMB: e.maxSizeMB,
		isRetryable: !1
	} : {
		kind: S.FILE_TOO_LARGE_NO_SIZE,
		maxSizeMB: e.maxSizeMB,
		isRetryable: !1
	};
	if (e.kind === x.COMPRESSION_INVALID) return {
		kind: S.UNSUPPORTED_FORMAT,
		mediaKind: e.mediaKind,
		isRetryable: !1
	};
	let t = e.status, n = e.userMessage;
	return t === b.PAYLOAD_TOO_LARGE ? {
		kind: S.PAYLOAD_TOO_LARGE,
		userMessage: n,
		isRetryable: !1
	} : t === b.UNSUPPORTED_MEDIA_TYPE ? {
		kind: S.UNSUPPORTED_MEDIA_TYPE,
		userMessage: n,
		isRetryable: !1
	} : t === b.TOO_MANY_REQUESTS ? {
		kind: S.RATE_LIMITED,
		userMessage: n,
		isRetryable: !0
	} : t === b.BAD_REQUEST ? {
		kind: S.BAD_REQUEST,
		userMessage: n,
		isRetryable: !1
	} : {
		kind: S.GENERIC,
		userMessage: n,
		isRetryable: !0
	};
}
//#endregion
//#region src/EventBusManager.ts
var an = class {
	handlers = /* @__PURE__ */ new Map();
	subscribe(e, t) {
		this.handlers.has(e) || this.handlers.set(e, /* @__PURE__ */ new Set());
		let n = this.handlers.get(e);
		return n.add(t), console.log(`[EventBus] Handler registered for "${e}" (${n.size} total)`), () => {
			this.unsubscribe(e, t);
		};
	}
	unsubscribe(e, t) {
		let n = this.handlers.get(e);
		n && (n.delete(t), console.log(`[EventBus] Handler unregistered for "${e}" (${n.size} remaining)`));
	}
	dispatch(e) {
		let t = this.handlers.get(e.type);
		if (!t || t.size === 0) {
			console.warn(`[EventBus] No handlers registered for event type "${e.type}"`);
			return;
		}
		console.log(`[EventBus] Dispatching "${e.type}" to ${t.size} handler(s)`);
		for (let n of t) try {
			n(e);
		} catch (t) {
			console.error(`[EventBus] Handler error for "${e.type}":`, t);
		}
	}
}, on = "/ws-v2", sn = {
	MESSAGE: "message",
	MESSAGE_DELETED: "message-deleted",
	MESSAGE_EDITED: "message-edited",
	CHAT_READ: "chat-read",
	CHAT_UNREAD: "chat-unread",
	COMMENT_ADDED: "comment-added",
	COMMENT_READ: "comment-read",
	NOTIFICATION_ADDED: "notification-added",
	NOTIFICATION_READ: "notification-read"
};
//#endregion
//#region src/isNumericValue.ts
function cn(e) {
	if (typeof e == "number") return !Number.isNaN(e);
	if (typeof e != "string") return !1;
	let t = e.trim();
	return t === "" ? !1 : !Number.isNaN(Number(t));
}
//#endregion
//#region src/workflowGrid.ts
var ln = 7;
function un(e) {
	return e.length === 0 ? 0 : Math.max(...e.map((e) => e.day));
}
function dn(e) {
	let t = e.columnsPerRow ?? ln;
	return Math.ceil((e.maxDay + 1) / t) * t;
}
function fn(e, t) {
	return Math.floor(e / (t ?? ln));
}
function pn(e, t) {
	let n = t ?? ln, r = e * n;
	return {
		startDay: r,
		endDay: r + n - 1
	};
}
function mn(e, t) {
	return fn(e, t) + 1;
}
//#endregion
//#region src/lexicalSchema.ts
var hn = l.enum([
	"left",
	"start",
	"center",
	"right",
	"end",
	"justify",
	""
]), gn = l.enum(["ltr", "rtl"]).nullable(), _n = l.object({
	type: l.literal("text"),
	mode: l.string(),
	text: l.string(),
	style: l.string(),
	detail: l.int(),
	format: l.int(),
	version: l.int()
}), vn = l.enum(["name"]), yn = _n.extend({
	type: l.literal("variable"),
	variable: vn
}), bn = l.object({
	type: l.literal("autolink"),
	rel: l.string().nullable(),
	url: l.string(),
	title: l.string().nullable(),
	format: hn,
	indent: l.int(),
	target: l.string().nullable(),
	version: l.int(),
	children: l.array(_n),
	direction: gn,
	isUnlinked: l.boolean()
}), xn = l.object({
	type: l.literal("linebreak"),
	format: hn.optional(),
	indent: l.int().optional(),
	version: l.int(),
	direction: gn.optional()
}), Sn = l.discriminatedUnion("type", [
	_n,
	bn,
	xn,
	yn
]), Cn = l.object({
	type: l.literal("paragraph"),
	format: hn,
	indent: l.int(),
	version: l.int(),
	children: l.array(Sn),
	direction: gn,
	textStyle: l.string(),
	textFormat: l.int()
}), wn = l.object({
	type: l.literal("root"),
	format: hn,
	indent: l.int(),
	version: l.int(),
	children: l.array(Cn),
	direction: gn
}), Tn = l.object({ root: wn });
function En(e) {
	return e;
}
//#endregion
//#region src/resolveMessageVariables.ts
function Dn(e, t) {
	return { root: {
		...e.root,
		children: e.root.children.map((e) => ({
			...e,
			children: e.children.map((e) => e.type === "variable" ? {
				type: "text",
				mode: "normal",
				text: t[e.variable],
				style: e.style,
				detail: 0,
				format: e.format,
				version: e.version
			} : e)
		}))
	} };
}
//#endregion
//#region src/rruleUtils.ts
var On = u.default ?? u, kn = On.RRule, C = On.Frequency;
function An(e, t = 1) {
	switch (e) {
		case C.DAILY: return 1 * t;
		case C.WEEKLY: return 7 * t;
		case C.MONTHLY: return 30 * t;
		default: return 1 * t;
	}
}
function jn(e) {
	if (!e) return null;
	try {
		let t = kn.fromString(e), n = t.options.freq, r = t.options.interval || 1, i = t.options.count || null, a = An(n, r), o;
		return o = n === C.DAILY && r === 1 ? "daily" : n === C.WEEKLY && r === 1 ? "weekly" : n === C.MONTHLY && r === 1 ? "monthly" : "custom", {
			frequency: o,
			interval: r,
			count: i,
			step: a
		};
	} catch {
		return null;
	}
}
function Mn(e, t) {
	return e ? Math.min(e, t) : t;
}
function Nn(e) {
	let t = new Date(e);
	return t.setHours(0, 0, 0, 0), t;
}
function Pn(e) {
	let t = new Date(e);
	return t.setHours(23, 59, 59, 999), t;
}
function Fn(e, t) {
	let n = new Date(e);
	return n.setDate(n.getDate() + t), n;
}
function In(e, t) {
	return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}
function Ln(e) {
	let t = new Date(e);
	return t.setUTCHours(0, 0, 0, 0), t;
}
function Rn(e) {
	let t = new Date(e);
	return t.setUTCHours(23, 59, 59, 999), t;
}
function zn(e, t) {
	let n = new Date(e);
	return n.setUTCDate(n.getUTCDate() + t), n;
}
//#endregion
//#region src/parseMMSSToSeconds.ts
function Bn(e) {
	let t = e.split(":");
	if (t.length === 2) {
		let e = parseInt(t[0], 10), n = parseInt(t[1], 10);
		return isNaN(e) || isNaN(n) ? 0 : e * 60 + n;
	}
	let n = parseInt(e, 10);
	return isNaN(n) ? 0 : n;
}
//#endregion
//#region src/formatDuration.ts
function Vn(e) {
	let t = Math.floor(e / 3600), n = Math.floor(e % 3600 / 60), r = e % 60, i = String(n).padStart(2, "0"), a = String(r).padStart(2, "0");
	return t > 0 ? `${String(t).padStart(2, "0")}:${i}:${a}` : `${i}:${a}`;
}
//#endregion
//#region src/formatActivityMetrics.ts
function w(e) {
	return e === null || e === 0 ? null : e < 1e3 ? `${Math.round(e)} m` : `${(e / 1e3).toFixed(1)} km`;
}
function T(e) {
	if (e === null || e === 0) return null;
	let t = Math.floor(e / 3600), n = Math.floor(e % 3600 / 60), r = Math.floor(e % 60);
	return t > 0 ? `${t}h ${n}m` : n > 0 ? `${n}m` : `${r}s`;
}
function Hn(e, t, n = "km") {
	if (e === null || t === null || e === 0) return null;
	let r = t / (e / (n === "km" ? 1e3 : 100)), i = Math.floor(r / 60), a = Math.floor(r % 60), o = n === "km" ? "/km" : "/100m";
	return `${i}:${a.toString().padStart(2, "0")} ${o}`;
}
function Un(e) {
	return e === null || e === 0 ? null : `${(e * 3.6).toFixed(1)} km/h`;
}
function E(e) {
	return e === null ? null : `${Math.round(e)} bpm`;
}
function D(e) {
	return e === null ? null : `+${Math.round(e)} m`;
}
function Wn(e) {
	return e === null ? null : `${Math.round(e)} W`;
}
function O(e) {
	return e === null ? null : `${Math.round(e)} kcal`;
}
function Gn(e) {
	return e === null ? null : `${Math.round(e)} spm`;
}
//#endregion
//#region src/buildActivityMetrics.ts
function k(e, t) {
	return t === null ? null : {
		label: e,
		value: t
	};
}
function A(e) {
	return e.filter((e) => e !== null);
}
function Kn(e) {
	return {
		primary: A([
			k("Distance", w(e.distance)),
			k("Duration", T(e.movingTime)),
			k("Pace", Hn(e.distance, e.movingTime, "km")),
			k("Avg HR", E(e.averageHeartrate))
		]),
		secondary: A([
			k("Max HR", E(e.maxHeartrate)),
			k("Elevation", D(e.elevation)),
			k("Calories", O(e.calories)),
			k("Cadence", Gn(e.averageCadence))
		])
	};
}
function qn(e) {
	return {
		primary: A([
			k("Distance", w(e.distance)),
			k("Duration", T(e.movingTime)),
			k("Avg Speed", Un(e.averageSpeed)),
			k("Avg Power", Wn(e.averagePower))
		]),
		secondary: A([
			k("Max HR", E(e.maxHeartrate)),
			k("Elevation", D(e.elevation)),
			k("Max Power", Wn(e.maxPower)),
			k("Calories", O(e.calories)),
			k("Cadence", Gn(e.averageCadence))
		])
	};
}
function Jn(e) {
	return {
		primary: A([
			k("Distance", w(e.distance)),
			k("Duration", T(e.movingTime)),
			k("Pace", Hn(e.distance, e.movingTime, "100m"))
		]),
		secondary: A([k("Calories", O(e.calories))])
	};
}
function Yn(e) {
	return {
		primary: A([
			k("Distance", w(e.distance)),
			k("Duration", T(e.movingTime)),
			k("Elevation", D(e.elevation))
		]),
		secondary: A([
			k("Avg HR", E(e.averageHeartrate)),
			k("Max HR", E(e.maxHeartrate)),
			k("Calories", O(e.calories))
		])
	};
}
function Xn(e) {
	return {
		primary: A([k("Duration", T(e.movingTime)), k("Calories", O(e.calories))]),
		secondary: []
	};
}
function Zn(e) {
	return {
		primary: A([
			k("Duration", T(e.movingTime)),
			k("Calories", O(e.calories)),
			k("Avg HR", E(e.averageHeartrate))
		]),
		secondary: A([k("Max HR", E(e.maxHeartrate))])
	};
}
function Qn(e) {
	return {
		primary: A([
			k("Duration", T(e.movingTime)),
			e.distance && e.distance > 0 ? k("Distance", w(e.distance)) : null,
			k("Calories", O(e.calories))
		]),
		secondary: []
	};
}
function $n(e) {
	switch (e.workoutType) {
		case "RUNNING":
		case "WALKING": return Kn(e);
		case "CYCLING": return qn(e);
		case "SWIMMING": return Jn(e);
		case "HIKING": return Yn(e);
		case "STRENGTH":
		case "YOGA": return Xn(e);
		case "CROSSFIT":
		case "HIIT": return Zn(e);
		default: return Qn(e);
	}
}
//#endregion
//#region src/unique.ts
function er(e, t) {
	let n = /* @__PURE__ */ new Set(), r = [];
	for (let i of e) {
		let e;
		e = typeof t == "function" ? t(i) : t ? i[t] : i, !n.has(e) && (n.add(e), r.push(i));
	}
	return r;
}
//#endregion
//#region src/exerciseThumbnail.ts
function tr(e) {
	try {
		return new URL(e);
	} catch {
		return null;
	}
}
function j(e, t) {
	return e.split("/")[t] || null;
}
function nr(e) {
	let t = tr(e);
	if (!t) return null;
	if (t.hostname === "www.youtube.com" || t.hostname === "youtube.com" || t.hostname === "m.youtube.com") {
		let e = t.searchParams.get("v");
		if (e) return e;
		let n = j(t.pathname, 1);
		return n === "shorts" || n === "embed" || n === "live" ? j(t.pathname, 2) : null;
	}
	return t.hostname === "youtu.be" ? j(t.pathname, 1) : null;
}
function rr(e) {
	let t = tr(e);
	return t ? j(t.pathname, 1) === "shorts" : !1;
}
function ir(e) {
	return e?.type === "youtube" && rr(e.sourceUrl) ? e : null;
}
function ar(e) {
	let t = tr(e);
	return !t || t.hostname !== "vimeo.com" && t.hostname !== "www.vimeo.com" ? null : t.pathname.split("/")[1] || null;
}
function or(e) {
	return e ? e.type === "image" ? e.url : e.thumbnailUrl : null;
}
function sr(e) {
	if (e.thumbnail !== void 0) return e.thumbnail;
	if (e.uploadedVideo?.url) return {
		type: "uploaded-video",
		videoUrl: e.uploadedVideo.url,
		thumbnailUrl: e.uploadedVideo.thumbnailUrl ?? null,
		fileKey: e.uploadedVideo.fileKey ?? "",
		isGif: e.uploadedVideo.isGif ?? !1
	};
	let t = e.videoURL ?? "";
	if (t) {
		let e = nr(t);
		if (e) return {
			type: "youtube",
			videoId: e,
			sourceUrl: t,
			thumbnailUrl: `https://img.youtube.com/vi/${e}/hqdefault.jpg`
		};
		let n = ar(t);
		if (n) return {
			type: "vimeo",
			videoId: n,
			sourceUrl: t,
			thumbnailUrl: `https://vumbnail.com/${n}.jpg`
		};
	}
	let n = e.images?.[0];
	return n ? {
		type: "image",
		url: n.url,
		imageId: n.imageId ?? ""
	} : null;
}
function cr(e) {
	return e ? e.type === "image" ? {
		type: "image",
		url: e.url
	} : e.thumbnailUrl ? {
		type: "image",
		url: e.thumbnailUrl
	} : e.type === "uploaded-video" ? {
		type: "uploaded-video-thumbnail",
		url: e.videoUrl
	} : null : null;
}
//#endregion
//#region src/aiChatTools.ts
var M = {
	getAthlete: "get-athlete",
	getProgram: "get-program",
	getWorkout: "get-workout",
	getCalendar: "get-calendar",
	getTask: "get-task",
	searchExercises: "search-exercises",
	search: "search",
	createProgram: "create-program",
	assignProgram: "assign-program",
	createWorkout: "create-workout",
	updateProgram: "update-program",
	updateWorkout: "update-workout",
	duplicateProgramWeek: "duplicate-program-week",
	addWorkoutItem: "add-workout-item",
	importSection: "import-section",
	groupWorkoutItems: "group-workout-items",
	ungroupWorkoutGroup: "ungroup-workout-group",
	updateWorkoutItem: "update-workout-item",
	moveWorkoutItem: "move-workout-item",
	addSet: "add-set",
	updateSet: "update-set",
	duplicateSet: "duplicate-set",
	createQuestionnaire: "create-questionnaire",
	createQuestionnaireItem: "create-questionnaire-item",
	getQuestionnaire: "get-questionnaire",
	getSubmission: "get-submission",
	updateQuestionnaireItems: "update-questionnaire-items",
	getExerciseHistory: "get-exercise-history",
	createCalendarItem: "create-calendar-item",
	moveCalendarItem: "move-calendar-item",
	updateAthlete: "update-athlete",
	delete: "delete"
};
function lr(e) {
	return Object.values(M).includes(e);
}
//#endregion
//#region src/legacyAIChatTools.ts
function N(e) {
	return e;
}
var ur = new Map([
	["search-library", {
		name: M.search,
		renamedAt: "2026-10-16",
		toArguments: N
	}],
	["get-calendar-item", {
		name: M.getCalendar,
		renamedAt: "2026-10-16",
		toArguments: N
	}],
	["get-program-workout", {
		name: M.getWorkout,
		renamedAt: "2026-10-16",
		toArguments: N
	}],
	["update-workout-item-attributes", {
		name: M.updateWorkoutItem,
		renamedAt: "2026-10-16",
		toArguments: N
	}],
	["replace-workout-item-exercise", {
		name: M.updateWorkoutItem,
		renamedAt: "2026-10-16",
		toArguments: N
	}],
	["delete-program-workout", {
		name: M.delete,
		renamedAt: "2026-10-16",
		toArguments: (e) => ({
			kind: "program-workout",
			ids: [e.programWorkoutId]
		})
	}],
	["delete-workout-item", {
		name: M.delete,
		renamedAt: "2026-10-16",
		toArguments: (e) => ({
			kind: "workout-item",
			ids: [e.workoutItemId]
		})
	}],
	["delete-set", {
		name: M.delete,
		renamedAt: "2026-10-16",
		toArguments: (e) => ({
			kind: "set",
			ids: [e.setId]
		})
	}],
	["delete-questionnaire-items", {
		name: M.delete,
		renamedAt: "2026-10-16",
		toArguments: (e) => ({
			kind: "questionnaire-item",
			ids: e.itemIds
		})
	}]
]), dr = [
	"SUPER_SET",
	"WARM_UP",
	"WORKOUT",
	"COOLDOWN",
	"RECOVERY"
], fr = [
	"REGULAR",
	"AMRAP",
	"TIMED",
	"FREESTYLE"
];
function pr(e) {
	return e !== "AMRAP" && e !== "TIMED";
}
function mr(e) {
	return e === "SUPER_SET";
}
function hr(e) {
	return e != null && e !== "SUPER_SET";
}
//#endregion
//#region src/featureFlags.ts
var gr = {
	aiIntegration: "aiIntegration",
	athleteFilters: "athleteFilters",
	organizations: "organizations",
	periodizationPlanner: "periodizationPlanner"
}, _r = 5, vr = 5 * 1024 * 1024, yr = [
	"image/jpeg",
	"image/png",
	"image/webp"
];
function br(e) {
	return yr.some((t) => t === e);
}
//#endregion
//#region src/socialLinks.ts
var xr = [
	{
		id: "instagram",
		label: "Instagram",
		placeholder: "sztama",
		urlPrefix: "https://www.instagram.com/",
		hostnames: ["instagram.com"]
	},
	{
		id: "youtube",
		label: "YouTube",
		placeholder: "sztama",
		urlPrefix: "https://www.youtube.com/@",
		hostnames: ["youtube.com", "youtu.be"]
	},
	{
		id: "tiktok",
		label: "TikTok",
		placeholder: "sztama",
		urlPrefix: "https://www.tiktok.com/@",
		hostnames: ["tiktok.com"]
	},
	{
		id: "email",
		label: "Email",
		placeholder: "hello@sztama.app",
		urlPrefix: "mailto:",
		hostnames: []
	},
	{
		id: "x",
		label: "X",
		placeholder: "sztama",
		urlPrefix: "https://x.com/",
		hostnames: ["x.com", "twitter.com"]
	},
	{
		id: "facebook",
		label: "Facebook",
		placeholder: "sztama",
		urlPrefix: "https://www.facebook.com/",
		hostnames: ["facebook.com"]
	},
	{
		id: "linkedin",
		label: "LinkedIn",
		placeholder: "sztama",
		urlPrefix: "https://www.linkedin.com/in/",
		hostnames: ["linkedin.com"]
	},
	{
		id: "threads",
		label: "Threads",
		placeholder: "sztama",
		urlPrefix: "https://www.threads.net/@",
		hostnames: ["threads.net"]
	}
];
function Sr(e) {
	return xr.find((t) => t.id === e) ?? null;
}
function Cr(e, t) {
	let n = jr(t);
	if (!n) return null;
	if (n.startsWith("http")) return n;
	let r = Sr(e);
	return r ? r.id === "email" ? n.startsWith("mailto:") ? n : `mailto:${n}` : `${r.urlPrefix}${n}` : n;
}
function wr(e) {
	let t = e.trim();
	return /^(https?:|mailto:|tel:)/i.test(t) ? t : /^[a-z][a-z0-9+.-]*:/i.test(t) ? null : t ? `https://${t}` : null;
}
function Tr(e, t) {
	if (!t) return "";
	let n = t.trim(), r = Sr(e);
	if (!r) return n;
	if (r.id === "email" && n.startsWith("mailto:")) return n.slice(7);
	if (r.id !== "email") {
		let e = Or(r.id, n);
		if (e) return e;
	}
	return n.startsWith(r.urlPrefix) ? Ar(n.slice(r.urlPrefix.length)) : n.replace(/^@+/, "");
}
function Er(e) {
	let t = e.trim();
	if (t.toLowerCase().startsWith("mailto:")) return {
		displayValue: t.slice(7).split("?", 1)[0],
		type: "email"
	};
	if (t.toLowerCase().startsWith("tel:")) return {
		displayValue: t.slice(4).split("?", 1)[0],
		type: "phone"
	};
	try {
		let e = new URL(t), n = Mr(e.hostname), r = Dr(n), i = r && r.id !== "email" ? kr(r.id, e) : null;
		return {
			displayValue: i ? `@${i}` : n,
			type: r?.id ?? "link"
		};
	} catch {
		return {
			displayValue: t,
			type: "link"
		};
	}
}
function Dr(e) {
	return xr.find((t) => t.hostnames.some((t) => Nr(e, t))) ?? null;
}
function Or(e, t) {
	try {
		let n = new URL(t), r = Sr(e), i = Mr(n.hostname);
		return r?.hostnames.some((e) => Nr(i, e)) ? kr(e, n) : null;
	} catch {
		return null;
	}
}
function kr(e, t) {
	let n = t.pathname.split("/").filter(Boolean), r;
	switch (e) {
		case "instagram":
			r = [
				"explore",
				"p",
				"reel",
				"reels",
				"stories"
			].includes(n[0] ?? "") ? void 0 : n[0];
			break;
		case "youtube":
			r = n[0]?.startsWith("@") ? n[0] : ["c", "user"].includes(n[0] ?? "") ? n[1] : void 0;
			break;
		case "tiktok":
		case "threads":
			r = n[0]?.startsWith("@") ? n[0] : void 0;
			break;
		case "x":
			r = [
				"home",
				"i",
				"intent",
				"search",
				"share"
			].includes(n[0] ?? "") ? void 0 : n[0];
			break;
		case "facebook":
			r = [
				"events",
				"groups",
				"profile.php",
				"reel",
				"reels",
				"share",
				"watch"
			].includes(n[0] ?? "") ? void 0 : n[0];
			break;
		case "linkedin":
			r = n[0] === "in" ? n[1] : void 0;
			break;
	}
	return r?.replace(/^@+/, "") || null;
}
function Ar(e) {
	return e.split(/[?#]/, 1)[0].replace(/^@+/, "").replace(/\/+$/, "");
}
function jr(e) {
	return e.trim().replace(/^@+/, "").replace(/^\/+/, "");
}
function Mr(e) {
	return e.toLowerCase().replace(/^www\./, "");
}
function Nr(e, t) {
	return e === t || e.endsWith(`.${t}`);
}
//#endregion
//#region src/billing.ts
function Pr(e, t) {
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: t.toUpperCase(),
		currencyDisplay: "code"
	}).format(e / 100);
}
function Fr(e, t) {
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: t.toUpperCase(),
		currencyDisplay: "code",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	}).format(e / 100);
}
function Ir(e) {
	let t = typeof e == "string" ? new Date(e) : e;
	return Math.max(0, Math.floor((t.getTime() - Date.now()) / 864e5));
}
function Lr(e) {
	let t = typeof e == "string" ? new Date(e) : e;
	return Math.max(0, Math.ceil((t.getTime() - Date.now()) / 36e5));
}
//#endregion
//#region src/appFeatures.ts
var Rr = {
	completeCoachingWorkspace: "completeCoachingWorkspace",
	advancedProgramBuilder: "advancedProgramBuilder",
	coachProfile: "coachProfile",
	mobileApp: "mobileApp",
	contentHub: "contentHub",
	trainingGroups: "trainingGroups",
	organizations: "organizations",
	sellProducts: "sellProducts"
}, zr = {
	RUNNING: "RUNNING",
	CYCLING: "CYCLING"
};
function P(e) {
	return Number(e.replace(",", "."));
}
function Br(e) {
	return e.replace(/^,\s*/, "").trim();
}
var Vr = {
	I: 1,
	II: 2,
	III: 3,
	IV: 4,
	V: 5,
	VI: 6,
	VII: 7
};
function F(e) {
	return /^[1-7]$/.test(e) ? Number(e) : Vr[e.toUpperCase()] ?? null;
}
function Hr(e) {
	return /^[Zz](\d|I{1,3}|IV|V|VI|VII)(?:-[Zz]?(?:\d|I{1,3}|IV|V|VI|VII))?$/.test(e);
}
function Ur(e) {
	let t = /^[Zz](\d|I{1,3}|IV|V|VI|VII)(?:-[Zz]?(\d|I{1,3}|IV|V|VI|VII))?$/.exec(e);
	if (t == null) return null;
	let n = F(t[1]);
	if (n == null) return null;
	let r = t[2], i = r == null ? n : F(r);
	return i == null ? null : {
		low: n,
		high: i
	};
}
function Wr(e, t) {
	switch (e) {
		case "m":
		case "mtr": return t;
		case "km": return t * 1e3;
		case "mi": return t * 1609.344;
		default: return null;
	}
}
function Gr(e, t) {
	switch (e) {
		case "s": return t;
		case "min": return t * 60;
		case "h": return t * 3600;
		default: return null;
	}
}
var I = p({
	name: "Ident",
	pattern: /[A-Za-z][A-Za-z0-9.]*/
}), Kr = p({
	name: "WhiteSpace",
	pattern: /\s+/,
	group: f.SKIPPED
}), L = p({
	name: "TimeTok",
	pattern: /\d+:\d+/
}), R = p({
	name: "NumberTok",
	pattern: /\d+[.,]\d+|\d+/
}), z = p({
	name: "Unit",
	pattern: /mtr|min|bpm|km|mi|m|s|h/,
	longer_alt: I
}), qr = p({
	name: "XTok",
	pattern: /[xX](?![A-Za-z])|\*|×/
}), Jr = p({
	name: "Apos",
	pattern: /'/
}), Yr = p({
	name: "DQuot",
	pattern: /"/
}), Xr = p({
	name: "Pct",
	pattern: /%/
}), Zr = p({
	name: "LParen",
	pattern: /\(/
}), Qr = p({
	name: "RParen",
	pattern: /\)/
}), $r = p({
	name: "Slash",
	pattern: /\//
}), B = p({
	name: "At",
	pattern: /@/
}), ei = p({
	name: "Plus",
	pattern: /\+/
}), ti = p({
	name: "Dash",
	pattern: /-/
}), ni = p({
	name: "NoteTok",
	pattern: /,[^\n]*/
}), ri = [
	Kr,
	L,
	R,
	Jr,
	Yr,
	Xr,
	Zr,
	Qr,
	$r,
	B,
	ei,
	ti,
	qr,
	z,
	ni,
	I
], ii = new f(ri), ai = class extends d {
	sport = zr.RUNNING;
	actionIssues = [];
	constructor() {
		super(ri, { recoveryEnabled: !0 }), this.performSelfAnalysis();
	}
	segment = this.RULE("segment", () => this.OR([{
		GATE: () => this.LA(1).tokenType === R && this.LA(2).tokenType === qr,
		ALT: () => this.SUBRULE(this.repeatExpr)
	}, { ALT: () => this.SUBRULE(this.atom) }]));
	line = this.RULE("line", () => {
		let e = this.SUBRULE(this.segment);
		return this.CONSUME(ee), e;
	});
	repeatExpr = this.RULE("repeatExpr", () => {
		let e = this.CONSUME(R);
		this.CONSUME(qr);
		let t = [];
		this.OR1([{ ALT: () => {
			this.CONSUME(Zr);
			let e = this.SUBRULE1(this.segment);
			e != null && t.push(e), this.MANY(() => {
				this.CONSUME(ei);
				let e = this.SUBRULE2(this.segment);
				e != null && t.push(e);
			}), this.CONSUME(Qr);
		} }, { ALT: () => {
			let e = this.SUBRULE3(this.segment);
			e != null && t.push(e);
		} }]);
		let n, r = [], i = [];
		this.OPTION(() => {
			this.CONSUME($r);
			let e = this.SUBRULE(this.quantity);
			e != null && (n = e), this.MANY2({
				GATE: () => this.LA(1).tokenType === B,
				DEF: () => {
					this.CONSUME(B);
					let e = this.SUBRULE(this.target);
					e != null && i.push(e);
				}
			});
		});
		let a = this.SUBRULE2(this.tagList), o;
		return this.OPTION2(() => {
			o = Br(this.CONSUME(ni).image);
		}), {
			kind: "repeat",
			count: P(e.image),
			body: t,
			restTail: n,
			restTailTargets: i,
			tailTags: r,
			tags: a,
			note: o
		};
	});
	atom = this.RULE("atom", () => {
		let e = this.SUBRULE(this.quantity);
		if (e == null) return null;
		let t;
		this.OPTION(() => {
			this.CONSUME($r);
			let e = this.SUBRULE2(this.quantity);
			e != null && (t = e);
		});
		let n = [], r = [];
		this.MANY({
			GATE: () => this.LA(1).tokenType === B,
			DEF: () => {
				this.CONSUME(B);
				let e = this.SUBRULE(this.target);
				e != null && n.push(e);
			}
		});
		let i;
		return this.OPTION2(() => {
			i = Br(this.CONSUME(ni).image);
		}), {
			kind: "step",
			quantity: e,
			pair: t,
			targets: n,
			tags: r,
			note: i
		};
	});
	quantity = this.RULE("quantity", () => this.OR([{ ALT: () => {
		let e = this.CONSUME(L).image.split(":");
		return {
			durationType: "TIME",
			value: Number(e[0]) * 60 + Number(e[1])
		};
	} }, { ALT: () => {
		let e = P(this.CONSUME(R).image);
		return this.OR2([
			{ ALT: () => {
				this.CONSUME(Jr);
				let t = e * 60;
				return this.OPTION(() => {
					let e = this.CONSUME2(R);
					this.CONSUME(Yr), t += P(e.image);
				}), {
					durationType: "TIME",
					value: t
				};
			} },
			{ ALT: () => (this.CONSUME2(Yr), {
				durationType: "TIME",
				value: e
			}) },
			{ ALT: () => {
				let t = this.CONSUME(z).image.toLowerCase(), n = Wr(t, e);
				if (n != null) return {
					durationType: "DISTANCE",
					value: n
				};
				let r = Gr(t, e);
				return r == null ? null : {
					durationType: "TIME",
					value: r
				};
			} }
		]);
	} }]));
	target = this.RULE("target", () => {
		let e = !1;
		this.OPTION({
			GATE: () => {
				let e = this.LA(1);
				return e.tokenType === I && e.image.toLowerCase() === "ramp";
			},
			DEF: () => {
				this.CONSUME(I), e = !0;
			}
		});
		let t = this.OR([
			{
				GATE: () => this.LA(1).tokenType === L,
				ALT: () => this.SUBRULE(this.paceTarget)
			},
			{
				GATE: () => {
					let e = this.LA(1);
					if (e.tokenType !== I) return !1;
					if (Hr(e.image)) return !0;
					if (/^[Zz]$/.test(e.image)) {
						let e = this.LA(2);
						return e.tokenType === I && F(e.image) != null;
					}
					return !1;
				},
				ALT: () => this.SUBRULE(this.zoneTarget)
			},
			{
				GATE: () => this.LA(1).tokenType === R,
				ALT: () => this.SUBRULE(this.numberTarget)
			}
		]);
		if (e && t != null) {
			let e = t.targetLow ?? 0, n = t.targetHigh ?? 0;
			return e <= n ? {
				...t,
				targetMode: "RAMP_UP"
			} : {
				...t,
				targetLow: n,
				targetHigh: e,
				targetMode: "RAMP_DOWN"
			};
		}
		return t;
	});
	paceTarget = this.RULE("paceTarget", () => {
		let e = oi(this.CONSUME(L).image), t = e;
		this.OPTION(() => {
			this.CONSUME(ti), t = oi(this.CONSUME2(L).image);
		}), this.CONSUME($r);
		let n = Wr(this.CONSUME(z).image.toLowerCase(), 1);
		return n == null ? null : this.sport === "CYCLING" ? (this.actionIssues.push({ message: "pace targets aren't supported for cycling — use power (W or % FTP) or heart rate" }), null) : {
			targetType: "PACE",
			targetLow: Math.round(1e3 / n * e),
			targetHigh: Math.round(1e3 / n * t)
		};
	});
	zoneTarget = this.RULE("zoneTarget", () => {
		let e = this.CONSUME(I), t, n;
		if (/^[Zz]$/.test(e.image)) {
			let e = F(this.CONSUME2(I).image);
			if (e == null) return null;
			t = e, n = e;
		} else {
			let r = Ur(e.image);
			if (r == null) return null;
			t = r.low, n = r.high;
		}
		let r = this.sport === "CYCLING" ? "POWER_ZONE" : "HR_ZONE", i = this.SUBRULE(this.zoneQualifierOpt);
		return i === "power" ? r = "POWER_ZONE" : i === "hr" ? r = "HR_ZONE" : i === "pace" && (r = "PACE"), {
			targetType: r,
			targetLow: t,
			targetHigh: n
		};
	});
	zoneQualifierOpt = this.RULE("zoneQualifierOpt", () => {
		let e = null;
		return this.OPTION({
			GATE: () => {
				let e = this.LA(1);
				if (e.tokenType !== I) return !1;
				let t = e.image.toLowerCase();
				return t === "hr" || t === "power" || t === "pace";
			},
			DEF: () => {
				e = this.CONSUME(I).image.toLowerCase();
			}
		}), e;
	});
	numberTarget = this.RULE("numberTarget", () => {
		let e = P(this.CONSUME(R).image), t = e;
		return this.OPTION(() => {
			this.CONSUME(ti), t = P(this.CONSUME2(R).image);
		}), this.OR([
			{
				GATE: () => this.LA(1).tokenType === Xr,
				ALT: () => {
					this.CONSUME(Xr);
					let n = "";
					return this.OPTION1({
						GATE: () => {
							let e = this.LA(1);
							if (e.tokenType !== I) return !1;
							let t = e.image.toLowerCase();
							return t === "hrmax" || t === "hr" || t === "lthr" || t === "ftp";
						},
						DEF: () => {
							n = this.CONSUME2(I).image.toLowerCase();
						}
					}), n === "ftp" || n === "" && this.sport === "CYCLING" ? {
						targetType: "POWER_PERCENT",
						targetLow: Math.round(e),
						targetHigh: Math.round(t)
					} : n === "lthr" ? {
						targetType: "LTHR_PERCENT",
						targetLow: Math.round(e),
						targetHigh: Math.round(t)
					} : {
						targetType: "HEART_RATE_PERCENT",
						targetLow: Math.round(e),
						targetHigh: Math.round(t)
					};
				}
			},
			{
				GATE: () => {
					let e = this.LA(1);
					return e.tokenType === I && /^w$/i.test(e.image);
				},
				ALT: () => (this.CONSUME1(I), {
					targetType: "POWER",
					targetLow: Math.round(e),
					targetHigh: Math.round(t)
				})
			},
			{
				GATE: () => {
					let e = this.LA(1);
					return e.tokenType === z && e.image.toLowerCase() === "bpm";
				},
				ALT: () => (this.CONSUME(z), {
					targetType: "HEART_RATE",
					targetLow: Math.round(e),
					targetHigh: Math.round(t)
				})
			},
			{
				GATE: () => {
					let e = this.LA(1);
					return e.tokenType === I && /^(rpm|spm)$/i.test(e.image);
				},
				ALT: () => (this.CONSUME3(I), {
					targetType: "CADENCE",
					targetLow: Math.round(e),
					targetHigh: Math.round(t)
				})
			},
			{
				GATE: () => this.sport === "CYCLING",
				ALT: () => ({
					targetType: "POWER",
					targetLow: Math.round(e),
					targetHigh: Math.round(t)
				})
			}
		]);
	});
	tagList = this.RULE("tagList", () => []);
};
function oi(e) {
	let t = e.split(":");
	return Number(t[0]) * 60 + Number(t[1]);
}
var V = new ai();
function si(e, t) {
	for (let t of e) if (t.intensity != null) return t.intensity;
	return t;
}
function ci(e) {
	for (let t of e) if (t.zone != null) return t.zone;
	return null;
}
function li(e, t, n) {
	let r = si(e.tags, n), i = e.targets[0], a = e.targets[1], o = ci(e.tags), s = {
		order: t,
		intensity: r,
		durationType: e.quantity.durationType,
		durationValue: e.quantity.value,
		targetType: i?.targetType ?? (o == null ? "OPEN" : "HR_ZONE")
	};
	i == null ? o != null && (s.targetLow = o, s.targetHigh = o) : (s.targetLow = i.targetLow, s.targetHigh = i.targetHigh, i.targetMode != null && i.targetMode !== "RANGE" && (s.targetMode = i.targetMode)), a != null && (s.secondaryTargetType = a.targetType, s.secondaryTargetLow = a.targetLow, s.secondaryTargetHigh = a.targetHigh, a.targetMode != null && a.targetMode !== "RANGE" && (s.secondaryTargetMode = a.targetMode));
	let c = [...e.tags.filter((e) => e.intensity == null && e.zone == null).map((e) => e.label ?? "").filter((e) => e.length > 0)];
	e.note != null && e.note.length > 0 && c.push(e.note), c.length > 0 && (s.notes = c.join(" · "));
	let l = [s];
	return e.pair != null && l.push({
		order: t + 1,
		intensity: "REST",
		durationType: e.pair.durationType,
		durationValue: e.pair.value,
		targetType: "OPEN"
	}), l;
}
function ui(e, t, n) {
	let r = [], i = t;
	for (let t of e) {
		if (t.kind === "step") {
			let e = li(t, i, n);
			r.push(...e), i += e.length;
			continue;
		}
		let e = i, a = si(t.tags, "INTERVAL"), o = ui(t.body, i, a);
		if (t.note != null && t.note.length > 0 && o[0] != null) {
			let e = o[0].notes;
			o[0].notes = e != null && e.length > 0 ? `${e} · ${t.note}` : t.note;
		}
		if (r.push(...o), i += o.length, t.restTail != null) {
			let e = t.restTailTargets[0], n = t.restTailTargets[1], a = {
				order: i,
				intensity: si(t.tailTags, "RECOVERY"),
				durationType: t.restTail.durationType,
				durationValue: t.restTail.value,
				targetType: e?.targetType ?? "OPEN"
			};
			e != null && (a.targetLow = e.targetLow, a.targetHigh = e.targetHigh, e.targetMode != null && e.targetMode !== "RANGE" && (a.targetMode = e.targetMode)), n != null && (a.secondaryTargetType = n.targetType, a.secondaryTargetLow = n.targetLow, a.secondaryTargetHigh = n.targetHigh, n.targetMode != null && n.targetMode !== "RANGE" && (a.secondaryTargetMode = n.targetMode)), r.push(a), i += 1;
		}
		r.push({
			order: i,
			intensity: a,
			durationType: "REPEAT_UNTIL_STEPS_CMPLT",
			durationValue: t.count,
			repeatFromStepOrder: e,
			targetType: "OPEN"
		}), i += 1;
	}
	return r;
}
function di(e, t) {
	let n = ii.tokenize(e);
	V.input = n.tokens, V.sport = t.sport ?? zr.RUNNING, V.actionIssues = [];
	let r = V.line(), i = [];
	for (let e of n.errors) i.push({ message: `Lex: ${e.message}` });
	for (let e of V.errors) i.push({ message: e.message });
	for (let e of V.actionIssues) i.push(e);
	let a = t.defaultIntensity ?? "ACTIVE";
	return r == null ? {
		steps: [{
			order: t.orderStart,
			intensity: a,
			durationType: "OPEN",
			targetType: "OPEN",
			unparsed: e,
			notes: "could not parse"
		}],
		issues: i
	} : {
		steps: ui([r], t.orderStart, a),
		issues: i
	};
}
function fi(e) {
	return ii.tokenize(e).tokens;
}
//#endregion
//#region src/dsl/parseWorkout.ts
function pi(e) {
	let t = e.toLowerCase();
	return t.includes("warmup") || t.includes("warm-up") || t.includes("warm up") || t.startsWith("w:") ? "WARMUP" : t.includes("cooldown") || t.includes("cool-down") || t.includes("cool down") || t.startsWith("cd:") ? "COOLDOWN" : "ACTIVE";
}
var mi = /^\s*-\s+/;
function hi(e) {
	let t = [], n = 0, r = 1;
	for (let i of e.split("\n")) t.push({
		lineNo: r,
		offset: n,
		text: i
	}), n += i.length + 1, r += 1;
	return t;
}
function gi(e) {
	return e.text.trim().length === 0;
}
function _i(e, t = {}) {
	if (e.trim().length === 0) return {
		status: "empty",
		sections: [],
		errors: []
	};
	let n = t.sport, r = t.thresholds, i = hi(e), a = [], o = [], s = null;
	function c() {
		if (s == null) return;
		let e = s.header;
		s.stepLines.length === 0 && o.push({
			message: `Section "${e.text.trim()}" has no steps — add one or more lines starting with "- ".`,
			line: e.lineNo,
			offset: e.offset,
			length: e.text.length
		});
		let t = [], i = 0, c = pi(e.text);
		for (let e of s.stepLines) {
			let a = di(e.text.replace(mi, "").trim(), {
				orderStart: i,
				defaultIntensity: c,
				sport: n,
				thresholds: r
			});
			t.push(...a.steps), i += a.steps.length;
			for (let t of a.issues) o.push({
				message: t.message,
				line: e.lineNo,
				offset: e.offset,
				length: e.text.length
			});
		}
		a.push({
			name: e.text.trim(),
			steps: t
		}), s = null;
	}
	for (let e of i) {
		if (gi(e)) {
			c();
			continue;
		}
		if (mi.test(e.text)) {
			if (s == null) {
				s = {
					header: {
						lineNo: e.lineNo,
						offset: e.offset,
						text: ""
					},
					stepLines: [e]
				};
				continue;
			}
			s.stepLines.push(e);
			continue;
		}
		c(), s = {
			header: e,
			stepLines: []
		};
	}
	return c(), a.length === 0 && o.length === 0 ? {
		status: "partial",
		sections: [],
		errors: [{ message: "No sections parsed — first line is a section name, following lines start with \"- \"." }]
	} : o.length > 0 ? {
		status: a.length > 0 ? "partial" : "fatal",
		sections: a,
		errors: o
	} : {
		status: "valid",
		sections: a,
		errors: []
	};
}
function vi(e) {
	let t = 0;
	for (let n of e) t += n.steps.length;
	return t;
}
//#endregion
//#region src/dsl/zoneColors.ts
var yi = {
	1: "#86efac",
	2: "#22c55e",
	3: "#a3e635",
	4: "#f59e0b",
	5: "#ea580c",
	6: "#dc2626",
	7: "#7f1d1d"
}, bi = {
	1: "#0a0a0a",
	2: "#0a0a0a",
	3: "#0a0a0a",
	4: "#0a0a0a",
	5: "#FFFFFF",
	6: "#FFFFFF",
	7: "#FFFFFF"
}, xi = "#e5e7eb", Si = "#71717a", Ci = "#cbd5e1", wi = "#0f172a", Ti = {
	1: "Z1",
	2: "Z2",
	3: "Z3",
	4: "Z4",
	5: "Z5",
	6: "Z6",
	7: "Z7"
}, Ei = {
	1: "Z1 · Recovery",
	2: "Z2 · Endurance",
	3: "Z3 · Tempo",
	4: "Z4 · Threshold",
	5: "Z5 · VO2max",
	6: "Z6 · Anaerobic",
	7: "Z7 · Sprint"
}, Di = {
	1: "60–70 %",
	2: "70–80 %",
	3: "80–90 %",
	4: "90–95 %",
	5: "95–100 %",
	6: "100–115 %",
	7: "115–130 %"
};
function Oi(e) {
	return Number.isInteger(e) && e >= 1 && e <= 7;
}
function H(e, t = 185) {
	let n = t > 0 ? e / t : 0;
	return n < .7 ? 1 : n < .8 ? 2 : n < .9 ? 3 : n < .95 ? 4 : n < 1 ? 5 : n < 1.15 ? 6 : 7;
}
var ki = {
	1: "< 55 %",
	2: "55–75 %",
	3: "76–90 %",
	4: "91–105 %",
	5: "106–120 %",
	6: "121–150 %",
	7: "150 %+"
}, Ai = 250;
function U(e) {
	return e < .55 ? 1 : e < .76 ? 2 : e < .91 ? 3 : e < 1.06 ? 4 : e < 1.21 ? 5 : e < 1.51 ? 6 : 7;
}
function W(e, t = 250) {
	return t <= 0 ? 1 : U(e / t);
}
var ji = 270, Mi = 380 / 270, Ni = 330 / 270, Pi = 290 / 270, Fi = 260 / 270, Ii = 220 / 270, Li = 200 / 270;
function Ri(e, t = 270) {
	return t <= 0 || e > t * Mi ? 1 : e > t * Ni ? 2 : e > t * Pi ? 3 : e > t * Fi ? 4 : e > t * Ii ? 5 : e > t * Li ? 6 : 7;
}
//#endregion
//#region src/dsl/stepZone.ts
var zi = {
	WARMUP: 1,
	RECOVERY: 1,
	REST: 1,
	COOLDOWN: 1
};
function Bi(e, t) {
	let n = Vi(e.targetType, e.targetLow, e.targetHigh, t);
	if (n != null) return n;
	let r = Vi(e.secondaryTargetType ?? null, e.secondaryTargetLow, e.secondaryTargetHigh, t);
	if (r != null) return r;
	let i = zi[e.intensity];
	return i == null ? null : {
		low: i,
		high: i
	};
}
function Vi(e, t, n, r) {
	if (e == null || t == null || n == null) return null;
	if (e === "HR_ZONE" || e === "POWER_ZONE") return G(t, n);
	if (e === "POWER") {
		let e = r?.ftp ?? void 0;
		return G(W(t, e), W(n, e));
	}
	if (e === "POWER_PERCENT") return G(U(t / 100), U(n / 100));
	if (e === "HEART_RATE") {
		let e = r?.hrMax ?? void 0;
		return G(H(t, e), H(n, e));
	}
	if (e === "HEART_RATE_PERCENT") return G(H(t, 100), H(n, 100));
	if (e === "LTHR_PERCENT") {
		let e = r?.lthr ?? null, i = r?.hrMax ?? null;
		return e == null || i == null ? G(H(t, 100), H(n, 100)) : G(H(Math.round(e * t / 100), i), H(Math.round(e * n / 100), i));
	}
	if (e === "PACE") {
		let e = Ri((t + n) / 2, r?.thresholdPaceSecPerKm ?? void 0);
		return {
			low: e,
			high: e
		};
	}
	return null;
}
function Hi(e, t) {
	let n = Bi(e, t);
	return n == null ? null : Ui(Math.round((n.low + n.high) / 2));
}
function G(e, t) {
	return {
		low: Ui(Math.min(e, t)),
		high: Ui(Math.max(e, t))
	};
}
function Ui(e) {
	let t = Math.round(e);
	return Oi(t) ? t : t < 1 ? 1 : 7;
}
//#endregion
//#region src/dsl/chartData.ts
var Wi = 185, Gi = {
	1: [.6, .7],
	2: [.7, .8],
	3: [.8, .9],
	4: [.9, .95],
	5: [.95, 1],
	6: [1, 1.15],
	7: [1.15, 1.3]
};
function K(e, t, n) {
	let r = Gi[e]?.[0] ?? .6, i = Gi[t]?.[1] ?? 1;
	return {
		low: Math.round(n * r),
		high: Math.round(n * i)
	};
}
function Ki(e) {
	switch (e) {
		case "WARMUP": return 2;
		case "COOLDOWN":
		case "RECOVERY":
		case "REST": return 1;
		case "INTERVAL": return 4;
		default: return 3;
	}
}
function qi(e, t = {}) {
	let n = t.hrMax ?? 185, r = t.lthr ?? n;
	if (e.targetType === "HR_ZONE" && e.targetLow != null && e.targetHigh != null) return K(e.targetLow, e.targetHigh, n);
	if (e.targetType === "HEART_RATE" && e.targetLow != null && e.targetHigh != null) return {
		low: e.targetLow,
		high: e.targetHigh
	};
	if (e.targetType === "HEART_RATE_PERCENT" && e.targetLow != null && e.targetHigh != null) return {
		low: Math.round(n * e.targetLow / 100),
		high: Math.round(n * e.targetHigh / 100)
	};
	if (e.targetType === "LTHR_PERCENT" && e.targetLow != null && e.targetHigh != null) return {
		low: Math.round(r * e.targetLow / 100),
		high: Math.round(r * e.targetHigh / 100)
	};
	if (e.secondaryTargetType === "HR_ZONE" && e.secondaryTargetLow != null && e.secondaryTargetHigh != null) return K(e.secondaryTargetLow, e.secondaryTargetHigh, n);
	if (e.secondaryTargetType === "HEART_RATE_PERCENT" && e.secondaryTargetLow != null && e.secondaryTargetHigh != null) return {
		low: Math.round(n * e.secondaryTargetLow / 100),
		high: Math.round(n * e.secondaryTargetHigh / 100)
	};
	if (e.secondaryTargetType === "LTHR_PERCENT" && e.secondaryTargetLow != null && e.secondaryTargetHigh != null) return {
		low: Math.round(r * e.secondaryTargetLow / 100),
		high: Math.round(r * e.secondaryTargetHigh / 100)
	};
	let i = Gi[Ki(e.intensity)] ?? [.6, .7];
	return {
		low: Math.round(n * i[0]),
		high: Math.round(n * i[1])
	};
}
var Ji = [
	{
		zone: 1,
		low: 111,
		high: 130
	},
	{
		zone: 2,
		low: 130,
		high: 148
	},
	{
		zone: 3,
		low: 148,
		high: 167
	},
	{
		zone: 4,
		low: 167,
		high: 176
	},
	{
		zone: 5,
		low: 176,
		high: 185
	},
	{
		zone: 6,
		low: 185,
		high: 213
	},
	{
		zone: 7,
		low: 213,
		high: 241
	}
], q = {
	1: [.4, .55],
	2: [.55, .75],
	3: [.76, .9],
	4: [.91, 1.05],
	5: [1.06, 1.2],
	6: [1.21, 1.5],
	7: [1.51, 1.8]
};
function Yi(e, t, n) {
	let r = q[e]?.[0] ?? .4, i = q[t]?.[1] ?? .55;
	return {
		low: Math.round(n * r),
		high: Math.round(n * i)
	};
}
function Xi(e, t = 250) {
	if (e.targetType === "POWER" && e.targetLow != null && e.targetHigh != null) return {
		low: e.targetLow,
		high: e.targetHigh
	};
	if (e.targetType === "POWER_PERCENT" && e.targetLow != null && e.targetHigh != null) return {
		low: Math.round(t * e.targetLow / 100),
		high: Math.round(t * e.targetHigh / 100)
	};
	if (e.targetType === "POWER_ZONE" && e.targetLow != null && e.targetHigh != null) return Yi(e.targetLow, e.targetHigh, t);
	if (e.secondaryTargetType === "POWER" && e.secondaryTargetLow != null && e.secondaryTargetHigh != null) return {
		low: e.secondaryTargetLow,
		high: e.secondaryTargetHigh
	};
	if (e.secondaryTargetType === "POWER_PERCENT" && e.secondaryTargetLow != null && e.secondaryTargetHigh != null) return {
		low: Math.round(t * e.secondaryTargetLow / 100),
		high: Math.round(t * e.secondaryTargetHigh / 100)
	};
	if (e.secondaryTargetType === "POWER_ZONE" && e.secondaryTargetLow != null && e.secondaryTargetHigh != null) return Yi(e.secondaryTargetLow, e.secondaryTargetHigh, t);
	let n = q[Ki(e.intensity)] ?? [.4, .55];
	return {
		low: Math.round(t * n[0]),
		high: Math.round(t * n[1])
	};
}
var Zi = [
	1,
	2,
	3,
	4,
	5,
	6,
	7
].map((e) => {
	let t = q[e] ?? [0, 0];
	return {
		zone: e,
		low: Math.round(250 * t[0]),
		high: Math.round(250 * t[1])
	};
});
function Qi(e) {
	switch (e) {
		case "WARMUP":
		case "COOLDOWN": return 330;
		case "RECOVERY":
		case "REST": return 360;
		case "INTERVAL": return 240;
		default: return 300;
	}
}
function $i(e) {
	if (e.durationType === "TIME") return {
		seconds: e.durationValue ?? 30,
		estimated: !1
	};
	if (e.durationType === "DISTANCE") {
		let t = e.durationValue ?? 0;
		return t <= 0 ? {
			seconds: 30,
			estimated: !0
		} : e.targetType === "PACE" && e.targetLow != null && e.targetHigh != null ? {
			seconds: t * ((e.targetLow + e.targetHigh) / 2) / 1e3,
			estimated: !1
		} : {
			seconds: t * Qi(e.intensity) / 1e3,
			estimated: !0
		};
	}
	return {
		seconds: 30,
		estimated: !0
	};
}
function ea(e) {
	let t = [], n = /* @__PURE__ */ new Map();
	for (let r of e) {
		if (r.durationType === "REPEAT_UNTIL_STEPS_CMPLT") {
			let e = Math.max(1, Math.round(r.durationValue ?? 1)), i = r.repeatFromStepOrder;
			if (i == null) continue;
			let a = n.get(i);
			if (a == null) continue;
			let o = t.slice(a);
			for (let n = 1; n < e; n++) for (let e of o) t.push({ ...e });
			continue;
		}
		n.set(r.order, t.length), t.push({ ...r });
	}
	return t;
}
function ta(e, t = {}) {
	let n = [], r = [], i = 0, a = 0, o = t.sport === "CYCLING", s = t.thresholds, c = s?.ftp ?? void 0;
	for (let t of e) {
		let e = i, l = ea(t.steps);
		for (let e of l) {
			let r = $i(e), l = o ? null : qi(e, s), u = o ? Xi(e, c) : null;
			n.push({
				step: e,
				startSec: i,
				endSec: i + r.seconds,
				seconds: r.seconds,
				estimated: r.estimated,
				bpm: l == null ? 0 : Math.round((l.low + l.high) / 2),
				hrLow: l?.low ?? 0,
				hrHigh: l?.high ?? 0,
				watts: u == null ? 0 : Math.round((u.low + u.high) / 2),
				wattsLow: u?.low ?? 0,
				wattsHigh: u?.high ?? 0,
				zone: Hi(e, s),
				sectionName: t.name
			}), i += r.seconds, e.durationType === "DISTANCE" && (a += e.durationValue ?? 0);
		}
		r.push({
			name: t.name,
			startSec: e,
			endSec: i
		});
	}
	return {
		steps: n,
		sectionSpans: r,
		totalSeconds: i,
		totalMeters: a
	};
}
function na(e) {
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n], i = t[t.length - 1];
		if (i != null && i.bpm === r.bpm && i.watts === r.watts && i.intensity === r.step.intensity && i.zone === r.zone && i.sectionName === r.sectionName) {
			i.endSec = r.endSec, i.stepCount += 1, i.estimated = i.estimated || r.estimated;
			continue;
		}
		t.push({
			startSec: r.startSec,
			endSec: r.endSec,
			bpm: r.bpm,
			hrLow: r.hrLow,
			hrHigh: r.hrHigh,
			watts: r.watts,
			wattsLow: r.wattsLow,
			wattsHigh: r.wattsHigh,
			intensity: r.step.intensity,
			zone: r.zone,
			stepIndex: n,
			stepCount: 1,
			sectionName: r.sectionName,
			notes: r.step.notes,
			estimated: r.estimated
		});
	}
	return t;
}
var ra = [
	"WARMUP",
	"ACTIVE",
	"INTERVAL",
	"REST",
	"RECOVERY",
	"COOLDOWN"
];
function ia(e) {
	let t = /* @__PURE__ */ new Map(), n = 0;
	for (let r of e) t.set(r.step.intensity, (t.get(r.step.intensity) ?? 0) + r.seconds), n += r.seconds;
	return ra.filter((e) => (t.get(e) ?? 0) > 0).map((e) => {
		let r = t.get(e) ?? 0;
		return {
			intensity: e,
			seconds: r,
			pct: n > 0 ? r / n * 100 : 0
		};
	});
}
function aa(e) {
	let t = Math.max(0, Math.round(e)), n = Math.floor(t / 3600), r = Math.floor(t % 3600 / 60), i = t % 60;
	return n > 0 ? `${n}:${String(r).padStart(2, "0")}:${String(i).padStart(2, "0")}` : `${r}:${String(i).padStart(2, "0")}`;
}
function oa(e) {
	if (e >= 1e3) {
		let t = e / 1e3;
		return `${t % 1 == 0 ? t.toFixed(0) : t.toFixed(2)} km`;
	}
	return `${Math.round(e)} m`;
}
function sa(e) {
	let t = 0;
	for (let n of e) {
		let e = n.zone;
		e ?? (n.watts > 0 ? e = W(n.watts) : n.bpm > 0 && (e = H(n.bpm))), e != null && e > t && (t = e);
	}
	return t;
}
function ca(e) {
	return e.filter((e) => e.step.intensity === "INTERVAL").length;
}
//#endregion
//#region src/dsl/formatStep.ts
function J(e) {
	return e.durationType === "TIME" ? la(e.durationValue ?? 0) : e.durationType === "DISTANCE" ? ua(e.durationValue ?? 0) : e.durationType === "REPEAT_UNTIL_STEPS_CMPLT" ? `× ${e.durationValue ?? 0}` : "—";
}
function la(e) {
	if (e <= 0) return "0\"";
	let t = Math.floor(e / 3600), n = e - t * 3600, r = Math.floor(n / 60), i = Math.round(n - r * 60);
	return t > 0 ? r > 0 ? `${t}h${r}'` : `${t}h` : r > 0 ? i > 0 ? `${r}'${String(i).padStart(2, "0")}"` : `${r}'` : `${i}"`;
}
function ua(e) {
	if (e >= 1e3) {
		let t = e / 1e3;
		return `${Number.isInteger(t) ? t.toString() : t.toFixed(1)} km`;
	}
	return `${Math.round(e)}m`;
}
function da(e, t = {}) {
	return pa(e.targetType, e.targetLow, e.targetHigh, e.targetMode, t);
}
function fa(e, t = {}) {
	return e.secondaryTargetType == null ? null : pa(e.secondaryTargetType, e.secondaryTargetLow ?? null, e.secondaryTargetHigh ?? null, e.secondaryTargetMode ?? null, t);
}
function pa(e, t, n, r, i = {}) {
	if (e === "OPEN" || t == null) return null;
	if (r === "RAMP_UP" || r === "RAMP_DOWN") {
		let a = r === "RAMP_DOWN" ? n ?? t : t, o = r === "RAMP_DOWN" ? t : n ?? t, s = va(e, a, i.thresholds), c = va(e, o, i.thresholds);
		if (s != null && c != null) {
			let t = `Z${s} → Z${c}`, n = ha(e, Math.min(a, o), Math.max(a, o), i.thresholds);
			return n == null ? t : `${t} · ${n}`;
		}
		let l = ya(e, a), u = ya(e, o);
		return l == null || u == null ? null : `${l} → ${u}`;
	}
	let a = [
		ma(e, t, n, i.thresholds),
		_a(e, t, n),
		ha(e, t, n ?? t, i.thresholds)
	].filter(function(e) {
		return e != null;
	});
	return a.length > 0 ? a.join(" · ") : null;
}
function ma(e, t, n, r) {
	if (e === "HR_ZONE" || e === "POWER_ZONE") return n != null && n !== t ? `Z${t}-Z${n}` : `Z${t}`;
	if (e === "HEART_RATE") {
		let e = H(t, r?.hrMax ?? void 0), i = n != null && n !== t ? H(n, r?.hrMax ?? void 0) : e;
		return e === i ? `Z${e}` : `Z${e}-Z${i}`;
	}
	if (e === "POWER") {
		let e = W(t, r?.ftp ?? void 0), i = n != null && n !== t ? W(n, r?.ftp ?? void 0) : e;
		return e === i ? `Z${e}` : `Z${e}-Z${i}`;
	}
	return null;
}
function ha(e, t, n, r) {
	if (e === "HR_ZONE") {
		let e = r?.hrMax;
		if (e == null || e <= 0 || t < 1 || n > 5) return null;
		let i = K(t, n, e);
		return `${i.low}-${i.high} bpm`;
	}
	if (e === "POWER_ZONE") {
		let e = r?.ftp;
		if (e == null || e <= 0 || t < 1 || n > 7) return null;
		let i = Yi(t, n, e);
		return `${i.low}-${i.high}w`;
	}
	return e === "HEART_RATE_PERCENT" ? ga(t, n, r?.hrMax, "bpm") : e === "POWER_PERCENT" ? ga(t, n, r?.ftp, "W") : null;
}
function ga(e, t, n, r) {
	if (n == null || n <= 0) return null;
	let i = Math.round(n * e / 100), a = Math.round(n * t / 100);
	return `${i === a ? i.toString() : `${i}-${a}`} ${r}`;
}
function _a(e, t, n) {
	switch (e) {
		case "PACE": return n != null && n !== t ? `${ba(t)}-${ba(n)}/km` : `${ba(t)}/km`;
		case "HEART_RATE": return n != null && n !== t ? `${Math.round(t)}-${Math.round(n)} bpm` : `${Math.round(t)} bpm`;
		case "HEART_RATE_PERCENT": return n != null && n !== t ? `${Math.round(t)}-${Math.round(n)}% HRmax` : `${Math.round(t)}% HRmax`;
		case "LTHR_PERCENT": return n != null && n !== t ? `${Math.round(t)}-${Math.round(n)}% LTHR` : `${Math.round(t)}% LTHR`;
		case "POWER": return n != null && n !== t ? `${Math.round(t)}-${Math.round(n)}w` : `${Math.round(t)}w`;
		case "POWER_PERCENT": return n != null && n !== t ? `${Math.round(t)}-${Math.round(n)}% FTP` : `${Math.round(t)}% FTP`;
		case "SPEED": return n != null && n !== t ? `${t}-${n} km/h` : `${t} km/h`;
		case "CADENCE": return n != null && n !== t ? `${Math.round(t)}-${Math.round(n)} rpm` : `${Math.round(t)} rpm`;
		default: return null;
	}
}
function va(e, t, n) {
	return e === "HR_ZONE" || e === "POWER_ZONE" ? t : e === "HEART_RATE" ? H(t, n?.hrMax ?? void 0) : e === "POWER" ? W(t, n?.ftp ?? void 0) : null;
}
function ya(e, t) {
	switch (e) {
		case "PACE": return `${ba(t)}/km`;
		case "HEART_RATE_PERCENT": return `${Math.round(t)}%`;
		case "LTHR_PERCENT": return `${Math.round(t)}% LTHR`;
		case "POWER_PERCENT": return `${Math.round(t)}% FTP`;
		case "SPEED": return `${t} km/h`;
		case "CADENCE": return `${Math.round(t)} rpm`;
		default: return null;
	}
}
function ba(e) {
	let t = Math.floor(e / 60), n = Math.round(e - t * 60);
	return `${t}:${String(n).padStart(2, "0")}`;
}
//#endregion
//#region src/dsl/renderWorkoutDsl.ts
function xa(e, t) {
	let n = [];
	for (let r = 0; r < t.length; r++) {
		let i = t[r], a = [], o = Ea(i.steps);
		for (let t = 0; t < o.length; t++) {
			let n = o[t], s = n.notes.map(function(t, i) {
				return e.note({
					key: `note-${r}-${n.firstOrder}-${i}`,
					text: t
				});
			});
			a.push(e.step({
				key: `step-${r}-${n.firstOrder}`,
				text: n.text,
				sectionIndex: r,
				sectionName: i.name,
				stepOrder: n.firstOrder,
				sourceSteps: n.sourceSteps,
				children: s
			}));
		}
		n.push(e.section({
			key: `section-${r}`,
			title: i.name,
			sectionIndex: r,
			children: a
		})), r < t.length - 1 && n.push(e.spacer({ key: `spacer-${r}` }));
	}
	return e.document({ children: n });
}
function Sa(e) {
	if (e.sections.length > 0) return Ta(e.sections);
	let t = e.dslText ?? "";
	return t.trim().length > 0 ? wa(t) : Ta(e.sections);
}
function Ca(e, t = {}) {
	return { sections: e.map(function(e, n) {
		return {
			key: `section-${n}`,
			title: e.name,
			sectionIndex: n,
			children: Na(e.steps, n, t)
		};
	}) };
}
function wa(e) {
	let t = [], n = e.replace(/\r\n/g, "\n").replace(/\r/g, "\n").split("\n"), r = null, i = 0, a = 0;
	for (let e = 0; e < n.length; e++) {
		let o = n[e];
		if (o.trim().length === 0) {
			t.push({
				kind: "blank",
				key: `blank-${e}`,
				lineIndex: e
			});
			continue;
		}
		if (Ma(o)) {
			r ??= i, t.push({
				kind: "step",
				key: `step-${e}`,
				text: o,
				lineIndex: e,
				sectionIndex: r,
				stepOrder: a,
				notes: []
			}), a++;
			continue;
		}
		r = i, i++, a = 0, t.push({
			kind: "section",
			key: `section-${e}`,
			text: o,
			lineIndex: e,
			sectionIndex: r
		});
	}
	return { nodes: t };
}
function Ta(e) {
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		r.name != null && r.name.length > 0 && t.push({
			kind: "section",
			key: `section-${n}`,
			text: r.name,
			lineIndex: null,
			sectionIndex: n
		});
		let i = Ea(r.steps);
		for (let e = 0; e < i.length; e++) {
			let r = i[e];
			t.push({
				kind: "step",
				key: `step-${n}-${r.firstOrder}`,
				text: r.text,
				lineIndex: null,
				sectionIndex: n,
				stepOrder: r.firstOrder,
				notes: r.notes
			});
		}
		n < e.length - 1 && t.push({
			kind: "blank",
			key: `blank-${n}`,
			lineIndex: null
		});
	}
	return { nodes: t };
}
function Ea(e) {
	let t = [];
	for (let n of e) {
		if (n.durationType === "REPEAT_UNTIL_STEPS_CMPLT") {
			ja(t, n);
			continue;
		}
		ka(t, n) || Oa(t, n) || t.push(Da(n));
	}
	return t.map(function(e) {
		return {
			firstOrder: e.firstOrder,
			text: Y(e),
			notes: e.notes,
			sourceSteps: e.sourceSteps
		};
	});
}
function Da(e, t = {}) {
	return {
		firstOrder: e.order,
		duration: J(e),
		pair: null,
		target: da(e, t),
		secondaryTarget: fa(e, t),
		name: e.name ?? null,
		rendered: null,
		notes: e.notes != null && e.notes.length > 0 ? [e.notes] : [],
		sourceSteps: [e]
	};
}
function Y(e) {
	if (e.rendered != null) return e.rendered;
	let t = e.duration;
	return e.pair != null && (t += `/${e.pair}`), e.target != null && (t += ` @ ${e.target}`), e.secondaryTarget != null && (t += ` @ ${e.secondaryTarget}`), e.name != null && e.name.length > 0 ? `${e.name}: ${t}` : t;
}
function Oa(e, t) {
	if (t.intensity !== "REST" || t.targetType !== "OPEN" || t.name != null && t.name.length > 0) return !1;
	let n = e[e.length - 1];
	return n == null || n.rendered != null || n.pair != null ? !1 : (n.pair = J(t), t.notes != null && t.notes.length > 0 && n.notes.push(t.notes), n.sourceSteps.push(t), !0);
}
function ka(e, t) {
	if (!Aa(t.intensity) || t.name != null && t.name.length > 0) return !1;
	let n = e[e.length - 1];
	return n == null || n.rendered == null ? !1 : (n.rendered = `(${n.rendered})/${Y(Da(t))}`, t.notes != null && t.notes.length > 0 && n.notes.push(t.notes), n.sourceSteps.push(t), !0);
}
function Aa(e) {
	return e === "REST" || e === "RECOVERY";
}
function ja(e, t) {
	let n = t.durationValue ?? 0, r = t.repeatFromStepOrder ?? 0, i = e.findIndex(function(e) {
		return e.firstOrder >= r;
	});
	if (i === -1 || e.length === 0) {
		e.push({
			firstOrder: t.order,
			duration: "",
			pair: null,
			target: null,
			secondaryTarget: null,
			name: null,
			rendered: `× ${n}`,
			notes: t.notes != null && t.notes.length > 0 ? [t.notes] : [],
			sourceSteps: [t]
		});
		return;
	}
	let a = e.slice(i), o = a.map(Y), s = a.flatMap(function(e) {
		return e.notes;
	}), c = a.flatMap(function(e) {
		return e.sourceSteps;
	});
	c.push(t), t.notes != null && t.notes.length > 0 && s.push(t.notes), e.length = i, e.push({
		firstOrder: r,
		duration: "",
		pair: null,
		target: null,
		secondaryTarget: null,
		name: null,
		rendered: o.length === 1 ? `${n} x ${o[0]}` : `${n} x (${o.join(" + ")})`,
		notes: s,
		sourceSteps: c
	});
}
function Ma(e) {
	return /^\s*-\s+/.test(e);
}
function Na(e, t, n) {
	let r = [];
	for (let i of e) {
		if (i.durationType === "REPEAT_UNTIL_STEPS_CMPLT") {
			Ia(r, i, t);
			continue;
		}
		Fa(r, i, n) || r.push(Pa(i, t, n));
	}
	return r;
}
function Pa(e, t, n) {
	let r = Da(e, n);
	return {
		kind: "step",
		key: `structured-step-${t}-${e.order}`,
		text: Y(r),
		firstOrder: e.order,
		notes: r.notes,
		sourceSteps: r.sourceSteps,
		intensity: e.intensity
	};
}
function Fa(e, t, n) {
	if (t.intensity !== "REST" || t.targetType !== "OPEN" || t.name != null && t.name.length > 0) return !1;
	let r = e[e.length - 1];
	if (r == null || r.kind !== "step") return !1;
	let i = [...r.notes];
	t.notes != null && t.notes.length > 0 && i.push(t.notes);
	let a = r.sourceSteps[0], o = a == null ? null : Da(a, n);
	return o != null && (o.pair = J(t)), e[e.length - 1] = {
		...r,
		text: o == null ? `${r.text}/${J(t)}` : Y(o),
		notes: i,
		sourceSteps: [...r.sourceSteps, t]
	}, !0;
}
function Ia(e, t, n) {
	let r = t.repeatFromStepOrder ?? 0, i = e.findIndex(function(e) {
		return e.firstOrder >= r;
	});
	if (i === -1 || e.length === 0) {
		e.push({
			kind: "repeat",
			key: `structured-repeat-${n}-${t.order}`,
			text: `× ${t.durationValue ?? 0}`,
			count: t.durationValue ?? 0,
			firstOrder: t.order,
			notes: t.notes != null && t.notes.length > 0 ? [t.notes] : [],
			sourceSteps: [t],
			children: []
		});
		return;
	}
	let a = e.slice(i), o = a.flatMap(function(e) {
		return [...e.sourceSteps];
	}), s = Ba(a, t);
	o.push(t), e.length = i, e.push({
		kind: "repeat",
		key: `structured-repeat-${n}-${r}`,
		text: za(t.durationValue ?? 0, a),
		count: t.durationValue ?? 0,
		firstOrder: r,
		notes: s,
		sourceSteps: o,
		children: a
	});
}
function La(e) {
	let t = e.children[e.children.length - 1];
	return t == null || t.kind !== "step" || t.intensity !== "REST" && t.intensity !== "RECOVERY" ? null : t;
}
function Ra(e) {
	return e.text;
}
function za(e, t) {
	let n = La({
		kind: "repeat",
		key: "",
		text: "",
		count: e,
		firstOrder: 0,
		notes: [],
		sourceSteps: [],
		children: t
	}), r = n == null ? t : t.slice(0, t.length - 1), i = r.map(Ra).join(" + "), a = `${e} x ${r.length > 1 || n != null && r[0]?.kind === "repeat" ? `(${i})` : i}`;
	return n != null && (a += `/${n.text}`), a;
}
function Ba(e, t) {
	if (t.notes != null && t.notes.length > 0) return [t.notes];
	let n = e[0];
	if (n == null || n.notes.length === 0) return [];
	let r = n.notes;
	return e[0] = {
		...n,
		notes: []
	}, r;
}
//#endregion
//#region src/dsl/chartBackend.ts
function Va(e, t = {}) {
	return xa(Ha(t), e);
}
function Ha(e = {}) {
	let t = 0, n = e.sport === "CYCLING", r = e.thresholds, i = r?.ftp ?? void 0;
	return {
		document: function(e) {
			let n = e.children.flatMap(function(e) {
				return e.steps;
			}), r = e.children.flatMap(function(e) {
				return e.sectionSpans;
			}), i = e.children.reduce(function(e, t) {
				return e + t.totalMeters;
			}, 0);
			return {
				steps: n,
				sectionSpans: r,
				totalSeconds: t,
				totalMeters: i
			};
		},
		section: function(e) {
			let n = e.children.flatMap(function(e) {
				return e.steps;
			}), r = e.children.reduce(function(e, t) {
				return e + t.totalMeters;
			}, 0), i = n[0]?.startSec ?? t, a = n[n.length - 1]?.endSec ?? t;
			return {
				steps: n,
				sectionSpans: [{
					name: e.title ?? "",
					startSec: i,
					endSec: a
				}],
				totalSeconds: a,
				totalMeters: r
			};
		},
		step: function(e) {
			let n = a(e), r = 0;
			for (let e of n) e.step.durationType === "DISTANCE" && (r += e.step.durationValue ?? 0);
			return {
				steps: n,
				sectionSpans: [],
				totalSeconds: n[n.length - 1]?.endSec ?? t,
				totalMeters: r
			};
		},
		note: function() {
			return Ua();
		},
		spacer: function() {
			return Ua();
		}
	};
	function a(e) {
		let a = ea(e.sourceSteps), o = [];
		for (let s of a) {
			let a = $i(s), c = n ? null : qi(s, r), l = n ? Xi(s, i) : null;
			o.push({
				step: s,
				startSec: t,
				endSec: t + a.seconds,
				seconds: a.seconds,
				estimated: a.estimated,
				bpm: c == null ? 0 : Math.round((c.low + c.high) / 2),
				hrLow: c?.low ?? 0,
				hrHigh: c?.high ?? 0,
				watts: l == null ? 0 : Math.round((l.low + l.high) / 2),
				wattsLow: l?.low ?? 0,
				wattsHigh: l?.high ?? 0,
				zone: Hi(s, r),
				sectionName: e.sectionName ?? ""
			}), t += a.seconds;
		}
		return o;
	}
}
function Ua() {
	return {
		steps: [],
		sectionSpans: [],
		totalSeconds: 0,
		totalMeters: 0
	};
}
//#endregion
//#region src/dsl/stepToText.ts
function Wa(e) {
	let t = Math.max(0, Math.round(e)), n = Math.floor(t / 60), r = t % 60;
	return `${n}:${String(r).padStart(2, "0")}`;
}
function X(e) {
	return e.kind === "time" && e.unit === "s" ? `${e.value}s` : `${e.value}${e.unit}`;
}
function Ga(e) {
	if (e.paceFromSec == null) return "";
	let t = e.paceUnit === "mi" ? "/mi" : "/km";
	return e.paceToSec == null || e.paceToSec === e.paceFromSec ? `${Wa(e.paceFromSec)}${t}` : `${Wa(e.paceFromSec)}-${Wa(e.paceToSec)}${t}`;
}
function Ka(e) {
	let t = e.hr;
	if (t == null) return "";
	let n = t.high != null && t.high !== t.low ? `${t.low}-${t.high}` : `${t.low}`;
	switch (t.subkind) {
		case "zone": return t.high != null && t.high !== t.low ? `Z${t.low}-Z${t.high}` : `Z${t.low}`;
		case "bpm": return `${n} bpm`;
		case "pct_hrmax": return `${n}% HRmax`;
	}
}
function qa(e) {
	let t = e.power;
	if (t == null) return "";
	let n = t.high != null && t.high !== t.low ? `${t.low}-${t.high}` : `${t.low}`;
	switch (t.subkind) {
		case "zone": return t.high != null && t.high !== t.low ? `Z${t.low}-Z${t.high}` : `Z${t.low}`;
		case "watts": return `${n}W`;
		case "pct_ftp": return `${n}% FTP`;
	}
}
function Ja(e) {
	switch (e.kind) {
		case "none": return "";
		case "pace": return Ga(e);
		case "hr": return Ka(e);
		case "power": return qa(e);
	}
}
function Ya(e) {
	let t = Ja(e.target), n = t.length > 0 ? ` @ ${t}` : "";
	if (e.type === "warmup" || e.type === "cooldown") {
		let t = e.type === "warmup" ? "Warmup" : "Cooldown";
		return `\n${e.description.trim().length > 0 ? e.description.trim() : t}\n- ${X(e.duration)}${n}`;
	}
	if (e.type === "repeats") {
		let t = e.reps ?? 1, r = e.recovery == null ? "" : `/${X(e.recovery)}`;
		return `- ${t} x ${X(e.duration)}${r}${n}`;
	}
	return `- ${X(e.duration)}${n}`;
}
function Xa(e, t, n) {
	let r = e.slice(0, n), i = e.slice(n), a = r.length === 0 || r.endsWith("\n"), o = i.length === 0 || i.startsWith("\n"), s = t;
	return a || (s = `\n${s}`), o || (s = `${s}\n`), {
		text: r + s + i,
		caretAt: r.length + s.length
	};
}
//#endregion
//#region src/dsl/toSectionPayloads.ts
function Z(e) {
	return e == null ? null : Math.round(e);
}
function Za(e) {
	return {
		order: e.order,
		name: e.name ?? null,
		notes: e.notes ?? null,
		intensity: e.intensity,
		durationType: e.durationType,
		durationValue: Z(e.durationValue),
		repeatFromStepOrder: e.repeatFromStepOrder ?? null,
		targetType: e.targetType,
		targetLow: Z(e.targetLow),
		targetHigh: Z(e.targetHigh),
		secondaryTargetType: e.secondaryTargetType ?? null,
		secondaryTargetLow: Z(e.secondaryTargetLow),
		secondaryTargetHigh: Z(e.secondaryTargetHigh)
	};
}
function Qa(e) {
	let t = [];
	for (let n = 0; n < e.sections.length; n++) {
		let r = e.sections[n];
		t.push({
			order: n,
			name: r.name.length > 0 ? r.name : null,
			steps: r.steps.map(Za)
		});
	}
	return t;
}
//#endregion
//#region src/dsl/formatSection.ts
function $a(e) {
	let t = [], n = [];
	for (let r of e.steps) {
		if (r.notes != null && r.notes.length > 0 && n.push(r.notes), r.durationType === "REPEAT_UNTIL_STEPS_CMPLT") {
			ao(t, r);
			continue;
		}
		ro(t, r) || no(t, r) || t.push(eo(r));
	}
	return {
		text: t.map(to).join(" · "),
		notes: n
	};
}
function eo(e) {
	return {
		firstOrder: e.order,
		duration: J(e),
		pair: null,
		target: da(e),
		secondaryTarget: fa(e),
		tag: null,
		rendered: null
	};
}
function to(e) {
	if (e.rendered != null) return e.rendered;
	let t = e.duration;
	return e.pair != null && (t += `/${e.pair}`), e.tag != null && (t += ` ${e.tag}`), e.target != null && (t += ` @ ${e.target}`), e.secondaryTarget != null && (t += ` @ ${e.secondaryTarget}`), t;
}
function no(e, t) {
	if (t.intensity !== "REST" || t.targetType !== "OPEN" || t.notes != null && t.notes.length > 0 || t.name != null && t.name.length > 0) return !1;
	let n = e[e.length - 1];
	return n == null || n.rendered != null || n.pair != null ? !1 : (n.pair = J(t), !0);
}
function ro(e, t) {
	if (!io(t.intensity) || t.notes != null && t.notes.length > 0 || t.name != null && t.name.length > 0) return !1;
	let n = e[e.length - 1];
	return n == null || n.rendered == null ? !1 : (n.rendered = `(${n.rendered})/${to(eo(t))}`, !0);
}
function io(e) {
	return e === "REST" || e === "RECOVERY";
}
function ao(e, t) {
	let n = t.durationValue ?? 0, r = t.repeatFromStepOrder ?? 0, i = e.findIndex((e) => e.firstOrder >= r);
	if (i === -1 || e.length === 0) {
		e.push({
			firstOrder: t.order,
			duration: "",
			pair: null,
			target: null,
			secondaryTarget: null,
			tag: null,
			rendered: `× ${n}`
		});
		return;
	}
	let a = e.slice(i).map(to);
	e.length = i;
	let o;
	o = a.length === 1 ? `${n} x ${a[0]}` : `${n} x (${a.join(" + ")})`, e.push({
		firstOrder: r,
		duration: "",
		pair: null,
		target: null,
		secondaryTarget: null,
		tag: null,
		rendered: o
	});
}
//#endregion
//#region src/dsl/displaySections.ts
function oo(e, t, n, r = {}) {
	let i = t?.trim() ?? "";
	if (i.length > 0) {
		let e = _i(i, {
			sport: n ?? void 0,
			thresholds: r
		});
		if (e.sections.length > 0) return e.sections;
	}
	return e;
}
//#endregion
//#region src/dsl/sport.ts
var so = ["RUNNING", "CYCLING"];
function co(e) {
	return so.includes(e) ? e : null;
}
//#endregion
//#region src/dsl/workoutDistance.ts
function lo(e) {
	return ho(e.activityDistanceMeters) ? e.activityDistanceMeters : uo(e.sections);
}
function uo(e) {
	let t = 0;
	for (let n of e) t += fo(n.steps);
	return t;
}
function fo(e) {
	let t = e.slice().sort((e, t) => e.order - t.order);
	return po(t, 0, t.length);
}
function po(e, t, n) {
	let r = 0;
	for (let i = t; i < n; i += 1) {
		let n = e[i];
		if (n.durationType === "DISTANCE" && ho(n.durationValue)) {
			r += n.durationValue;
			continue;
		}
		if (n.durationType !== "REPEAT_UNTIL_STEPS_CMPLT" || n.repeatFromStepOrder == null || !ho(n.durationValue)) continue;
		let a = mo(e, n.repeatFromStepOrder);
		if (a < t || a >= i) continue;
		let o = Math.max(1, Math.round(n.durationValue)), s = po(e, a, i);
		r += s * (o - 1);
	}
	return r;
}
function mo(e, t) {
	for (let n = 0; n < e.length; n += 1) if (e[n].order === t) return n;
	return -1;
}
function ho(e) {
	return typeof e == "number" && Number.isFinite(e) && e > 0;
}
//#endregion
//#region src/dsl/workoutDuration.ts
var go = 60, _o = 1e3;
function vo(e) {
	let t = yo(e);
	return t == null ? null : Math.max(1, Math.round(t / go));
}
function yo(e) {
	let t = 0;
	for (let n of e) {
		let e = bo(n.steps);
		if (e == null) return null;
		t += e;
	}
	return t || null;
}
function bo(e) {
	let t = e.slice().sort((e, t) => e.order - t.order);
	return xo(t, 0, t.length);
}
function xo(e, t, n) {
	let r = 0;
	for (let i = t; i < n; i += 1) {
		let n = e[i];
		if (n.durationType === "REPEAT_UNTIL_STEPS_CMPLT") {
			let a = So(e, t, i, n);
			if (a == null) return null;
			r += a;
			continue;
		}
		let a = Co(n);
		if (a == null) return null;
		r += a;
	}
	return r || null;
}
function So(e, t, n, r) {
	if (r.repeatFromStepOrder == null || !r.durationValue) return null;
	let i = Eo(e, r.repeatFromStepOrder);
	if (i < t || i >= n) return null;
	let a = xo(e, i, n);
	return a == null ? null : a * (Math.round(r.durationValue) - 1);
}
function Co(e) {
	if (e.durationType === "TIME") return e.durationValue || null;
	if (e.durationType !== "DISTANCE" || !e.durationValue) return null;
	let t = wo(e);
	return t == null ? null : e.durationValue * t / _o;
}
function wo(e) {
	return e.targetType === "PACE" && e.targetLow && e.targetHigh ? To(e.targetLow, e.targetHigh) : e.secondaryTargetType === "PACE" && e.secondaryTargetLow && e.secondaryTargetHigh ? To(e.secondaryTargetLow, e.secondaryTargetHigh) : null;
}
function To(e, t) {
	return (e + t) / 2;
}
function Eo(e, t) {
	for (let n = 0; n < e.length; n += 1) if (e[n].order === t) return n;
	return -1;
}
//#endregion
//#region src/dsl/intensityColors.ts
var Do = {
	WARMUP: "#38bdf8",
	ACTIVE: "#94a3b8",
	INTERVAL: "#f97316",
	REST: "#d4d4d8",
	RECOVERY: "#a1a1aa",
	COOLDOWN: "#818cf8"
}, Oo = {
	WARMUP: "Warmup",
	ACTIVE: "Active",
	INTERVAL: "Interval",
	REST: "Rest",
	RECOVERY: "Recovery",
	COOLDOWN: "Cooldown"
};
//#endregion
//#region src/dsl/zonePercentages.ts
function ko(e, t) {
	let n = /* @__PURE__ */ new Map(), r = 0, i = 0;
	for (let a of e) {
		let e = ea(a.steps);
		for (let a of e) {
			let e = $i(a);
			i += e.seconds;
			let o = Bi(a, t);
			if (o == null) {
				r += e.seconds;
				continue;
			}
			let s = o.high - o.low + 1, c = e.seconds / s;
			for (let e = o.low; e <= o.high; e++) {
				let t = e;
				n.set(t, (n.get(t) ?? 0) + c);
			}
		}
	}
	let a = [];
	for (let e = 1; e <= 7; e++) {
		let t = e;
		(n.get(t) ?? 0) > 0 && a.push(t);
	}
	let o = [];
	if (a.length > 0) {
		let e = a[0], t = a[a.length - 1];
		for (let r = e; r <= t; r++) {
			let e = r, t = n.get(e) ?? 0;
			o.push({
				key: e,
				pct: i > 0 ? t / i * 100 : 0,
				seconds: t,
				used: t > 0
			});
		}
	}
	return r > 0 && o.push({
		key: "UNTRACKED",
		pct: i > 0 ? r / i * 100 : 0,
		seconds: r,
		used: !0
	}), {
		bands: o,
		totalSeconds: i,
		hasZones: a.length > 0
	};
}
//#endregion
//#region src/time/civilDate.ts
var Ao = 1440 * 60 * 1e3;
function jo(e) {
	return e.toISOString().slice(0, 10);
}
function Mo(e) {
	return new Date(Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()));
}
function No(e) {
	let t = e.split("T")[0];
	return /* @__PURE__ */ new Date(`${t}T00:00:00.000Z`);
}
function Po(e) {
	let t = e.indexOf("T");
	return t === -1 ? e : e.slice(0, t);
}
function Fo(e, t) {
	let n = Po(e), r = /* @__PURE__ */ new Date(`${n}T00:00:00.000Z`);
	return r.setUTCDate(r.getUTCDate() + t), r.toISOString().slice(0, 10);
}
function Io(e, t) {
	return Po(e) < Po(t);
}
function Lo(e, t) {
	let n = No(e).getTime(), r = No(t).getTime();
	return Math.round((r - n) / Ao);
}
//#endregion
//#region src/time/TimeProvider.tsx
var Ro = te(null), zo = "Europe/Warsaw", Bo = 864e5, Vo = Date.UTC(2024, 0, 8), Ho = Date.UTC(2024, 0, 7), Q = {
	fullDateWithWeekday: {
		weekday: "long",
		year: "numeric",
		month: "long",
		day: "numeric"
	},
	longDate: {
		year: "numeric",
		month: "long",
		day: "numeric"
	},
	shortDate: {
		month: "short",
		day: "numeric",
		year: "numeric"
	},
	monthDay: {
		month: "short",
		day: "numeric"
	},
	shortDateTime: {
		year: "numeric",
		month: "short",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit"
	},
	timeOnly: {
		hour: "2-digit",
		minute: "2-digit"
	}
};
function Uo(e) {
	return e ?? zo;
}
function Wo(e) {
	let t = re(() => ({
		viewerTz: Uo(e.viewerTz),
		locale: e.locale
	}), [e.viewerTz, e.locale]);
	return /* @__PURE__ */ ie(Ro.Provider, {
		value: t,
		children: e.children
	});
}
function Go(e, t) {
	return {
		viewerTz: e,
		locale: t,
		availableFormats: Object.keys(Q),
		getLocaleFirstDayOfWeek() {
			return is(t);
		},
		getLocaleWeekdays(e = is(t)) {
			return as(t, e);
		},
		formatCivilDate(e, n) {
			let [r, i, a] = ns(e), o = new Date(Date.UTC(r, i - 1, a));
			return new Intl.DateTimeFormat(t, {
				...rs(n, "longDate"),
				timeZone: "UTC"
			}).format(o);
		},
		civilDateKey(e) {
			return ts(e);
		},
		toCivilDate(e) {
			return ts(e);
		},
		addDaysToCivilDate(e, t) {
			return Fo(e, t);
		},
		civilDateToLocalDate(e) {
			let t = ns(e);
			return new Date(t[0], t[1] - 1, t[2]);
		},
		differenceInCivilDays(e, t) {
			return Lo(e, t);
		},
		civilDateOfInstant(t, n = e) {
			return Zo(typeof t == "string" ? new Date(t) : t, n);
		},
		instantOfClockTime(t, n, r, i = e) {
			return qo(t, n, r, i);
		},
		clockPartsInTz(t, n = e) {
			return Yo(t, n);
		},
		formatInstant(n, r) {
			return new Intl.DateTimeFormat(t, {
				...rs(r, "shortDateTime"),
				timeZone: e
			}).format(new Date(n));
		},
		formatInstantTime(n) {
			return new Intl.DateTimeFormat(t, {
				...Q.timeOnly,
				timeZone: e
			}).format(new Date(n));
		},
		formatInstantDate(n, r) {
			return new Intl.DateTimeFormat(t, {
				...rs(r, "monthDay"),
				timeZone: e
			}).format(new Date(n));
		},
		formatInstantDateInTz(e, n, r) {
			return new Intl.DateTimeFormat(t, {
				...rs(r, "monthDay"),
				timeZone: n
			}).format(new Date(e));
		},
		formatInstantDual(n, r, i = "for them") {
			let a = (e) => new Intl.DateTimeFormat(t, {
				hour: "2-digit",
				minute: "2-digit",
				timeZone: e
			}).format(new Date(n));
			return r === e ? a(e) : `${a(e)} · ${a(r)} ${i}`;
		},
		formatInstantTimeInTz(e, n) {
			return new Intl.DateTimeFormat(t, {
				...Q.timeOnly,
				timeZone: n
			}).format(new Date(e));
		},
		fromNow(e) {
			let { val: n, range: r } = we(typeof e == "string" ? new Date(e) : e);
			if (typeof Intl < "u" && typeof Intl.RelativeTimeFormat == "function") return new Intl.RelativeTimeFormat(t, { numeric: "auto" }).format(n, r);
			let i = Math.abs(n), a = i === 1 ? r : `${r}s`;
			return n < 0 ? `${i} ${a} ago` : `in ${i} ${a}`;
		}
	};
}
function Ko() {
	let e = ne(Ro);
	return m(e !== null, "useTime must be used inside <TimeProvider>"), Go(e.viewerTz, e.locale);
}
function qo(e, t, n, r) {
	let i = `${e}T${String(t).padStart(2, "0")}:${String(n).padStart(2, "0")}:00`, a = /* @__PURE__ */ new Date(`${i}Z`), o = $o(a, r), s = new Date(a.getTime() - o), c = $o(s, r);
	return c === o ? s : new Date(a.getTime() - c);
}
function Jo(e, t) {
	let n = new Intl.DateTimeFormat("en-US", {
		timeZone: t,
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
		hour12: !1
	}).formatToParts(e);
	return new Date($(n, "year"), $(n, "month") - 1, $(n, "day"), $(n, "hour") % 24, $(n, "minute"), $(n, "second"));
}
function Yo(e, t) {
	let n = new Intl.DateTimeFormat("en-US", {
		timeZone: t,
		hour: "2-digit",
		minute: "2-digit",
		hour12: !1
	}).formatToParts(e);
	return {
		hour: $(n, "hour") % 24,
		minute: $(n, "minute")
	};
}
var Xo = /* @__PURE__ */ new Map();
function Zo(e, t) {
	let n = Qo(t).formatToParts(e);
	return `${es(n, "year")}-${es(n, "month")}-${es(n, "day")}`;
}
function Qo(e) {
	let t = Xo.get(e);
	if (t) return t;
	let n = new Intl.DateTimeFormat("en-CA", {
		timeZone: e,
		year: "numeric",
		month: "2-digit",
		day: "2-digit"
	});
	return Xo.set(e, n), n;
}
function $o(e, t) {
	let n = new Intl.DateTimeFormat("en-US", {
		timeZone: t,
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
		hour12: !1
	}).formatToParts(e);
	return Date.UTC($(n, "year"), $(n, "month") - 1, $(n, "day"), $(n, "hour") % 24, $(n, "minute"), $(n, "second")) - e.getTime();
}
function es(e, t) {
	let n = e.find((e) => e.type === t);
	return m(n, `Missing "${t}" part in Intl.DateTimeFormat output`), n.value;
}
function $(e, t) {
	let n = Number(es(e, t));
	return m(Number.isFinite(n), `Non-numeric "${t}" part in Intl.DateTimeFormat output`), n;
}
function ts(e) {
	let t = e.indexOf("T");
	return t === -1 ? e : e.slice(0, t);
}
function ns(e) {
	let [t, n, r] = ts(e).split("-").map(Number);
	return [
		t,
		n,
		r
	];
}
function rs(e, t) {
	return e === void 0 ? Q[t] : typeof e == "string" ? Q[e] : e;
}
function is(e) {
	return [
		"en",
		"en-US",
		"en-CA",
		"ja-JP",
		"ko-KR"
	].some((t) => e === t || t.includes("-") && e.startsWith(`${t}-`)) ? "sunday" : "monday";
}
function as(e, t) {
	let n = new Intl.DateTimeFormat(e, {
		weekday: "narrow",
		timeZone: "UTC"
	}), r = t === "sunday" ? Ho : Vo;
	return Array.from({ length: 7 }, (e, t) => n.format(new Date(r + t * Bo)));
}
//#endregion
//#region src/products.ts
var os = 200, ss = 1e6, cs = {
	DAY: 1095,
	WEEK: 156,
	MONTH: 36,
	YEAR: 3
}, ls = 730, us = "NONE", ds = 100, fs = 5e3, ps = 50, ms = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/, hs = 3, gs = 50, _s = /^[A-Za-z0-9]+$/, vs = [
	"TRIALING",
	"ACTIVE",
	"PAST_DUE"
], ys = [
	"CANCELED",
	"UNPAID",
	"INCOMPLETE_EXPIRED"
];
function bs(e) {
	return e / 100;
}
function xs(e, t) {
	return `/c/${e}/p/${t}`;
}
//#endregion
//#region src/invoicing/pl.vat.ts
var Ss = [
	"RATE_23",
	"RATE_8",
	"RATE_5",
	"RATE_0",
	"EXEMPT"
], Cs = [
	"TURNOVER_LIMIT",
	"ACTIVITY_TYPE",
	"MINISTER_REGULATION",
	"EU_DIRECTIVE"
], ws = [...Ss], Ts = [...Cs, "CUSTOM"], Es = {
	key: "FAKTUROWNIA",
	country: "pl",
	name: "Fakturownia",
	vatRates: Ss,
	vatExemptionBases: [...Cs, "CUSTOM"]
}, Ds = {
	key: "INFAKT",
	country: "pl",
	name: "inFakt",
	vatRates: Ss,
	vatExemptionBases: Cs
}, Os = {
	[Es.key]: Es,
	[Ds.key]: Ds
}, ks = Os, As = Object.values(Os).map((e) => e.key), js = {
	RUNNING: "RUNNING",
	CYCLING: "CYCLING",
	SWIMMING: "SWIMMING",
	WALKING: "WALKING",
	HIKING: "HIKING",
	ROWING: "ROWING",
	OUTDOOR_RUN: "OUTDOOR_RUN",
	INDOOR_RUN: "INDOOR_RUN",
	TRAIL_RUN: "TRAIL_RUN",
	ROAD_BIKE: "ROAD_BIKE",
	INDOOR_BIKE: "INDOOR_BIKE",
	MOUNTAIN_BIKE: "MOUNTAIN_BIKE",
	AIRBIKE: "AIRBIKE",
	POOL_SWIM: "POOL_SWIM",
	OPEN_WATER_SWIM: "OPEN_WATER_SWIM"
}, Ms = Object.values(js), Ns = {
	RUNNING: "RUNNING",
	CYCLING: "CYCLING",
	SWIMMING: "SWIMMING",
	WALKING: "WALKING",
	HIKING: "HIKING",
	ROWING: "ROWING",
	OUTDOOR_RUN: "RUNNING",
	INDOOR_RUN: "RUNNING",
	TRAIL_RUN: "RUNNING",
	ROAD_BIKE: "CYCLING",
	INDOOR_BIKE: "CYCLING",
	MOUNTAIN_BIKE: "CYCLING",
	AIRBIKE: "CYCLING",
	POOL_SWIM: "SWIMMING",
	OPEN_WATER_SWIM: "SWIMMING"
};
function Ps(e) {
	return Ms.includes(e);
}
function Fs(e) {
	if (!Ps(e)) throw Error(`Unknown sport type: ${e}`);
	return e;
}
function Is(e) {
	return Ns[Fs(e)];
}
function Ls(e) {
	return Ms.filter((t) => Ns[t] === e);
}
//#endregion
export { Fe as $createVariableNode, Ie as $isVariableNode, M as AI_CHAT_TOOLS, Rr as APP_FEATURES, Jt as AnimatedGifTooLargeError, ce as CALENDAR_MAX_FETCH_WEEK_COUNT, St as CHAT_ATTACHMENT_STATUSES, y as CHAT_ERROR_CODES, _ as CHAT_MEDIA, Et as CHAT_MEDIA_COMPRESSION, Dt as CHAT_MEDIA_EXTENSIONS_BY_MIME, g as CHAT_MEDIA_MIME, xt as CHAT_QUERY_KEYS, b as CHAT_UPLOAD_HTTP_STATUS, Qt as ChatMediaUploadError, Ai as DEFAULT_FTP, Wi as DEFAULT_HRMAX, ji as DEFAULT_THRESHOLD_PACE, ys as ENDED_PRODUCT_SUBSCRIPTION_STATUSES, an as EventBusManager, Vt as FileTooLargeError, C as Frequency, Do as INTENSITY_COLORS, Oo as INTENSITY_LABELS, ws as INVOICE_VAT_RATES, ks as INVOICING_PROVIDERS, As as INVOICING_PROVIDER_KEYS, ur as LEGACY_AI_CHAT_TOOLS, vs as LIVE_PRODUCT_SUBSCRIPTION_STATUSES, h as MB, It as MESSAGE_EDIT_WINDOW_MS, Ao as MS_PER_DAY, us as NO_PRODUCT_FILTER, Cs as POLISH_VAT_EXEMPTION_BASES, Ss as POLISH_VAT_RATES, fs as PRODUCT_DESCRIPTION_MAX_LENGTH, ls as PRODUCT_MAX_TRIAL_DAYS, ds as PRODUCT_NAME_MAX_LENGTH, cs as PRODUCT_PRICE_MAX_INTERVAL_COUNT, ss as PRODUCT_PRICE_MAX_UNIT_AMOUNT, os as PRODUCT_PRICE_MIN_UNIT_AMOUNT, ps as PRODUCT_SLUG_MAX_LENGTH, ms as PRODUCT_SLUG_PATTERN, vr as PROFILE_LINK_THUMBNAIL_MAX_BYTES, _r as PROFILE_LINK_THUMBNAIL_MAX_MB, yr as PROFILE_LINK_THUMBNAIL_MIME_TYPES, gs as PROMO_CODE_MAX_LENGTH, hs as PROMO_CODE_MIN_LENGTH, _s as PROMO_CODE_PATTERN, xr as SOCIAL_PLATFORMS, Ms as SPORT_TYPE_VALUES, Ns as SPORT_TYPE_WORKOUT_TYPE, zr as Sport, js as SportType, it as TIME_GAP_MINUTES, Wo as TimeProvider, S as UPLOAD_ERROR_CLASSIFICATION_KIND, x as UPLOAD_ERROR_KIND, ae as UnreachableCaseError, Ts as VAT_EXEMPTION_BASES, Pe as VariableNode, Yt as VideoTooLargeAfterCompressionError, fr as WORKOUT_FORMATS, le as WORKOUT_GRID_MAX_SELECTION_COUNT, dr as WORKOUT_ITEM_GROUP_TYPES, sn as WS_EVENT_TYPES, on as WS_UPGRADE_PATH, Ji as ZONE_BOUNDARIES, Zi as ZONE_BOUNDARIES_FTP, yi as ZONE_COLORS, xi as ZONE_FILLER_COLOR, Si as ZONE_FILLER_TEXT_COLOR, ki as ZONE_FTP_RANGES, Ei as ZONE_FULL_LABELS, Di as ZONE_HR_RANGES, Ti as ZONE_LABELS, bi as ZONE_TEXT_COLORS, Ci as ZONE_UNTRACKED_COLOR, wi as ZONE_UNTRACKED_TEXT_COLOR, fi as __lexForTest, Fn as addDays, Fo as addDaysToCivilDate, zn as addDaysUTC, En as asLexicalJson, m as assert, H as bpmToZoneIndex, $n as buildActivityMetrics, nn as buildUploadError, An as calculateStepDays, lo as calculateWorkoutDistanceMeters, uo as calculateWorkoutDslDistanceMeters, vo as calculateWorkoutDslDurationMinutes, yo as calculateWorkoutDslDurationSeconds, fo as calculateWorkoutDslStepsDistanceMeters, bo as calculateWorkoutDslStepsDurationSeconds, pr as canWorkoutFormatHaveSupersets, Te as capitalize, Bt as chatErrorToCopyId, Po as civilDateOf, Zo as civilDateOfInstantInTz, Tt as classifyMessageContent, rn as classifyUploadError, Yo as clockPartsInTz, ue as convertFromUTCDate, de as convertToUTCDate, vi as countSteps, Ha as createChartDslBackend, Go as createUseTimeApi, Lo as differenceInCivilDays, Be as emptyLexicalState, $i as estimateStepDuration, ea as expandRepeats, ta as expandSections, zt as extractServerErrorCode, gr as featureFlagName, Gn as formatActivityCadence, O as formatActivityCalories, w as formatActivityDistance, T as formatActivityDuration, D as formatActivityElevation, E as formatActivityHeartRate, Hn as formatActivityPace, Wn as formatActivityPower, Un as formatActivitySpeed, Pr as formatBillingAmount, Fr as formatBillingAmountRounded, rt as formatCommentDate, Vn as formatDuration, oa as formatMeters, fa as formatSecondaryTarget, aa as formatSeconds, $a as formatSection, J as formatStepDuration, la as formatStepSeconds, da as formatTarget, U as ftpPctToZoneIndex, fe as genRandomColorHex, De as getAlphabetLetter, kt as getChatMediaMimeFromExtension, qe as getColorFromInitials, Je as getContrastTextColor, pe as getDaysBetween, Mn as getEffectiveLimit, Xe as getFileUrl, Oe as getInitials, Ft as getMaxBytesForMime, un as getMaxDay, bt as getMessageBorderRadius, Ze as getMessageDateInfo, je as getMuscleNamesByGroups, Ae as getMusclesGroups, mn as getNextWeekIndex, xs as getPublicProductPath, we as getRelativeTime, be as getReorderQuery, wr as getSafeProfileHref, Sr as getSocialPlatform, Cr as getSocialProfileUrl, Tr as getSocialUsernameFromUrl, Is as getSportTypeWorkoutType, Ls as getSportTypesOfWorkoutType, or as getThumbnailImageUrl, cr as getThumbnailPreviewImage, Ir as getTrialDaysLeft, Lr as getTrialHoursLeft, fn as getWeekIndex, pn as getWeekRange, ir as getYoutubeShortThumbnail, me as groupBy, K as heartRateZoneRange, Xa as insertSnippetAtCaret, qo as instantOfClockTimeInTz, ia as intensityDistribution, ca as intervalCount, lr as isAIChatToolName, Pt as isAllowedMediaMime, Xt as isAnimatedGifTooLargeError, Ct as isChatAttachmentInFlight, Rt as isChatErrorCode, $t as isChatMediaUploadError, Io as isCivilDateBefore, Ee as isDateWithoutTime, Nt as isDocumentMime, ye as isDown, ze as isEmptyLexicalState, Ht as isFileTooLargeError, jt as isImageMime, Re as isLexicalJsonState, cn as isNumericValue, he as isPhoneNumberValid, br as isProfileLinkThumbnailMimeType, In as isSameDay, hr as isSectionGroupType, Ps as isSportType, mr as isSupersetGroupType, ve as isUp, wt as isUploadedAttachment, Mt as isVideoMime, Zt as isVideoTooLargeAfterCompressionError, rr as isYoutubeShortUrl, Oi as isZoneIndex, Tn as lexicalJsonStateSchema, Me as lexicalStateToMarkdown, Le as lexicalStateToString, Jo as localLookingDateInTz, ge as mapBy, Ge as mapLexicalState, Ne as markdownToLexicalState, qt as messageContentSchema, vn as messageVariableSchema, ke as muscleGroups, _e as noop, Pn as normalizeToEndOfDay, Rn as normalizeToEndOfDayUTC, dn as normalizeToGridRows, Nn as normalizeToStartOfDay, Ln as normalizeToStartOfDayUTC, oe as orderUtils, se as orderUtilsMutable, Ri as paceToZoneIndex, en as parseChatMediaUploadError, No as parseDateAsUtcMidnight, Bn as parseMMSSToSeconds, jn as parseRRule, Er as parseSocialLink, di as parseStepLine, ar as parseVimeoId, _i as parseWorkout, nr as parseYoutubeId, sa as peakZoneReached, Yi as powerZoneRange, yt as processMessages, bs as productsFeePercent, xe as range, xa as renderDSL, Va as renderDslChartData, Ca as renderStructuredWorkoutDsl, Sa as renderWorkoutDsl, Ce as reorder, oo as resolveDisplaySections, sr as resolveExerciseThumbnail, Dn as resolveMessageVariables, Se as resolveProgramPhase, na as runsFromExpanded, co as sportForWorkoutType, qi as stepHeartRate, Xi as stepPower, Ya as stepToText, Hi as stepZone, Bi as stepZoneRange, We as stringToLexicalState, Qa as toSectionPayloads, Fs as toSportType, jo as toUtcDateString, Mo as toUtcMidnight, er as unique, Ko as useTime, W as wattsToZoneIndex, ko as zonePercentages };

//# sourceMappingURL=index.js.map